<!-- 官方标签 -->
<template>
  <div>
    <div class="attr-box" v-show="visible">
      <div class="attr-left-box" v-if="isShowLeft">
        <div class="search-line">
          <el-input
            v-model="searchValue"
            @keyup.enter.native="handleSearch"
            placeholder="请输入标签名称查询"
          ></el-input>
          <i class="el-icon-search" @click="handleSearch"></i>
        </div>
        <div class="attr-left-box-content">
          <!-- 左侧标签菜单 -->
          <div class="attr-leftbigProbox">
            <div class="attr-leftbigTabbox">
              <div
                class="attr-itemPro-wrap"
                :class="{
                  'attr-itemPro-wrapClick': leftWarpTitle == '常用标签',
                }"
                :key="'wrap' + 666666"
                @click="handleWrap({ firstLevelCategory: '常用标签' })"
                v-show="isCommonShow"
              >
                <span class="label-style-box">常用标签</span>
              </div>
              <div
                class="attr-itemPro-wrap"
                :class="{
                  'attr-itemPro-wrapClick':
                    leftWarpTitle == item.firstLevelCategory,
                }"
                v-for="(item, index) in dataList"
                :key="'wrap' + index"
                @click="handleWrap(item)"
                v-show="
                  item.searchWrap &&
                  filterCategory(item.firstLevelCategory) &&
                  showDdLabel(item)
                "
              >
                <span class="label-style-box">{{
                  item.firstLevelCategory
                }}</span>
              </div>
            </div>
          </div>
          <!-- 左侧标签列表 -->
          <div class="attr-leftbigbox" id="scrollEle2">
            <div class="attr-left">
              <div class="search-result" v-if="searchStatus">
                <span>查询结果</span>
                <span class="go-back" @click="goBack">
                  返回
                  <i class="el-icon-close"></i>
                </span>
              </div>
              <!-- 无数据提示 -->
              <div v-if="isNoData" class="noData">
                <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" alt />
                <span style="margin-left: -140px; color: #909399"
                  >暂无任何数据</span
                >
              </div>
              <!-- 常用标签 -->
              <div
                v-show="isCommonShow && isLoading"
                class="commonlyuse-label"
                :key="'wrap' + 7777"
              >
                <div class="commonlyuse-label-title">
                  <span class="commonlyuse-label-title-text">常用标签</span>
                  <span class="commonlyuse-label-title-num">{{
                    recentlyList.length + commonUseList.length
                  }}</span>
                </div>
                <div class="commonlyuse-label-content">
                  <div class="commonlyuse-label-content-label">
                    <jd-title label="最近使用">
                      <template #slotBox>
                        <el-popover
                          placement="right"
                          width="240"
                          trigger="hover"
                          popper-class="popoverTips"
                        >
                          <span>展示近1年使用次数top10的标签</span>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                            style="
                              width: 17px;
                              position: relative;
                              left: 5px;
                              top: 2px;
                            "
                            slot="reference"
                          />
                        </el-popover>
                      </template>
                    </jd-title>
                  </div>
                  <div class="attr-list">
                    <template v-for="(item, idx) in recentlyList">
                      <div
                        class="attr-padd"
                        v-if="item.searchItem && !item.isHide"
                        :key="'label' + idx"
                      >
                        <!-- 标签点击 -->
                        <div
                          class="attr-item"
                          v-labelZoom="{ name: item.labelMeaning }"
                          @click="attrClickTop(item)"
                        >
                          <template v-if="item.labelMeaning.length >= 10">
                            <el-tooltip
                              ref="tooltipRef"
                              effect="light"
                              :content="item.labelMeaning"
                              placement="top-start"
                              popper-class="toolTipSet"
                              :hide-after="0"
                              :open-delay="380"
                            >
                              <div class="over-ellipsis">
                                <span class="icon-dot" v-if="item.isNew"></span>
                                {{ item.labelMeaning }}
                              </div>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <div>
                              <span class="icon-dot" v-if="item.isNew"></span>
                              {{ item.labelMeaning }}
                            </div>
                          </template>
                          <!-- <img alt src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/gou.png" /> -->
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="commonlyuse-label-content">
                  <div class="commonlyuse-label-content-label">
                    <jd-title label="自定义设置"></jd-title>
                  </div>
                  <div class="attr-list">
                    <template v-for="(item, idx) in commonUseList">
                      <div
                        class="attr-padd"
                        v-if="item.searchItem && !item.isHide"
                        :key="'label' + idx"
                      >
                        <!-- 标签点击 -->
                        <div
                          class="attr-item"
                          v-labelZoom="{ name: item.labelMeaning }"
                          @click="attrClickTop(item)"
                        >
                          <template v-if="item.labelMeaning.length >= 10">
                            <el-tooltip
                              ref="tooltipRef"
                              effect="light"
                              :content="item.labelMeaning"
                              placement="top-start"
                              popper-class="toolTipSet"
                              :hide-after="0"
                              :open-delay="380"
                            >
                              <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="100"
                                :open-delay="350"
                                ref="popoverRef"
                              >
                                <div class="over-ellipsis" slot="reference">
                                  <span
                                    class="icon-dot"
                                    v-if="item.isNew"
                                  ></span>
                                  {{ item.labelMeaning }}
                                </div>
                                <div class="tips">
                                  <span
                                    class="noCommon"
                                    v-if="item.commonUse"
                                    @click="setCommonUse(item, 0)"
                                  >
                                    <img
                                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/取消常用.png"
                                      alt=""
                                    />
                                    取消常用
                                  </span>
                                </div>
                              </el-popover>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <el-popover
                              placement="right"
                              width="100"
                              trigger="hover"
                              popper-class="popoverSet"
                              :close-delay="1"
                              :open-delay="350"
                              ref="popoverRef"
                            >
                              <div slot="reference">
                                <span class="icon-dot" v-if="item.isNew"></span>
                                {{ item.labelMeaning }}
                              </div>
                              <div class="tips">
                                <span
                                  class="noCommon"
                                  v-if="item.commonUse"
                                  @click="setCommonUse(item, 0)"
                                >
                                  <img
                                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/取消常用.png"
                                    alt=""
                                  />
                                  取消常用
                                </span>
                              </div>
                            </el-popover>
                          </template>
                          <!-- <img alt src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/gou.png" /> -->
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <!-- 标签菜单 -->
              <div
                v-show="item.searchWrap && showDdLabel(item)"
                class="commonlyuse-label"
                :class="{
                  attrActive: filterCategory(item.firstLevelCategory) == false,
                }"
                v-for="(item, index) in dataList"
                :key="'wrap' + index"
              >
                <div
                  class="commonlyuse-label-title"
                  v-show="
                    filterCategory(item.firstLevelCategory) && showDdLabel(item)
                  "
                  :id="item.firstLevelCategory + '2'"
                >
                  <span class="commonlyuse-label-title-text">{{
                    item.firstLevelCategory
                  }}</span>
                  <span
                    class="commonlyuse-label-title-num"
                    v-if="item.firstLevelCategory == '品类标签'"
                    >{{ item.labelCount - 3 }}</span
                  >
                  <span
                    class="commonlyuse-label-title-num"
                    v-if="item.firstLevelCategory == '品牌标签'"
                    >{{ item.labelCount - 1 }}</span
                  >
                  <span class="commonlyuse-label-title-num" v-else>{{
                    showDdCount(item)
                  }}</span>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_gaoji.svg"
                    style="width: 50px; margin-left: 2px"
                    v-if="
                      item.firstLevelCategory == '品牌标签' &&
                      (advanced[0] == 'hide:brand:tag' ||
                        advanced[1] == 'hide:brand:tag')
                    "
                  />
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_gaoji.svg"
                    style="width: 50px; margin-left: 2px"
                    v-if="
                      item.firstLevelCategory == '品类标签' &&
                      (advanced[0] == 'hide:cate:tag' ||
                        advanced[1] == 'hide:cate:tag')
                    "
                  />
                  <el-tooltip
                    v-if="item.firstLevelCategory == '互动标签'"
                    class="item"
                    effect="dark"
                    content="互动标签仅支持同步参与了在【京获客】或【云舟-互动管理】创建的活动且已开卡的人群，如需同步所有互动用户建议创建活动时设置仅限会员参与。"
                    placement="bottom"
                  >
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                      alt=""
                      style="
                        width: 17px;
                        margin-bottom: -3px;
                        margin-left: 3px;
                        cursor: pointer;
                      "
                    />
                  </el-tooltip>
                </div>
                <div
                  class="commonlyuse-label-content"
                  v-show="filterCategory(item.firstLevelCategory)"
                  v-for="(labelItem, labelIndex) in item.data"
                  :key="labelIndex"
                >
                  <div
                    class="commonlyuse-label-content-label"
                    v-show="labelItem.searchTitle && showDdLabel(item)"
                  >
                    <jd-title :label="labelItem.secondLevelCategory">
                      <template #slotBox>
                        <img
                          v-if="isNewImg(labelItem.secondLevelCategory)"
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_new_x.png"
                          alt=""
                        />
                      </template>
                    </jd-title>
                  </div>
                  <div class="attr-list">
                    <template v-for="(label, idx) in labelItem.data">
                      <!-- <span v-show="filterCategory(label.labelMeaning) && showDdAttr(label)" :key="'label' + idx"> -->
                      <div
                        class="attr-padd"
                        v-if="label.searchItem && !label.isHide"
                        v-show="
                          filterCategory(label.labelMeaning) &&
                          showDdAttr(label)
                        "
                        :key="'label' + idx"
                      >
                        <!-- 标签点击 -->
                        <div
                          class="attr-item"
                          id="popoverEl"
                          v-labelZoom="{ name: label.labelMeaning }"
                          @click="attrClick(label, item, labelItem)"
                        >
                          <template v-if="label.labelMeaning.length >= 10">
                            <el-tooltip
                              ref="tooltipRef"
                              effect="light"
                              :content="label.labelMeaning"
                              placement="top-start"
                              popper-class="toolTipSet"
                              :hide-after="0"
                              :open-delay="400"
                            >
                              <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="100"
                                :open-delay="350"
                                ref="popoverRef"
                                :offset="0"
                              >
                                <div class="over-ellipsis" slot="reference">
                                  <span
                                    class="icon-dot"
                                    v-if="label.isNew"
                                  ></span>
                                  {{ label.labelMeaning }}
                                </div>
                                <div class="tips">
                                  <span
                                    class="noCommon"
                                    v-if="label.commonUse"
                                    @click="setCommonUse(label, 0)"
                                  >
                                    <img
                                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/取消常用.png"
                                      alt=""
                                    />
                                    取消常用
                                  </span>
                                  <span
                                    class="common"
                                    style="color: #666666"
                                    v-else
                                    @click="setCommonUse(label, 1)"
                                  >
                                    <img
                                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/设为常用.png"
                                      alt=""
                                    />
                                    设为常用
                                  </span>
                                </div>
                              </el-popover>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <el-popover
                              placement="right"
                              width="100"
                              trigger="hover"
                              popper-class="popoverSet"
                              :close-delay="1"
                              :open-delay="350"
                              ref="popoverRef"
                            >
                              <div slot="reference">
                                <span
                                  class="icon-dot"
                                  v-if="label.isNew"
                                ></span>
                                {{ label.labelMeaning }}
                              </div>
                              <div class="tips">
                                <span
                                  class="noCommon"
                                  v-if="label.commonUse"
                                  @click="setCommonUse(label, 0)"
                                >
                                  <img
                                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/取消常用.png"
                                    alt=""
                                  />
                                  取消常用
                                </span>
                                <span
                                  class="common"
                                  style="color: #666666"
                                  v-else
                                  @click="setCommonUse(label, 1)"
                                >
                                  <img
                                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/设为常用.png"
                                    alt=""
                                  />
                                  设为常用
                                </span>
                              </div>
                            </el-popover>
                          </template>
                          <!-- <img alt src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/gou.png" /> -->
                        </div>
                      </div>
                      <!-- </span> -->
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右测详情内容 -->
      <div class="attr-rightbigbox">
        <!-- <div
          :class="[
            'attr-rightbigbox-top',
            { 'attr-rightbigbox__empty': defaultShow },
          ]"
        >
          <div class="top-line">
            <jd-title label="标签组合规则" class="rule-title"></jd-title>
            <div class="right-title-tip">
              （多个标签之间是交集的关系，如需更灵活的人群交并差，可在客户分群-人群运算或者精准营销功能中进行）
            </div>
          </div>
        </div> -->
        <!-- <div class="right-scroll"> -->
        <div :class="['attr-right', { 'attr-right__empty': defaultShow }]">
          <div
            class="filter-content-right-box-empty"
            v-if="dataListSelect.length === 0 && defaultShow == true"
          >
            <img
              class="filter-content-right-box-empty-img"
              :src="`https://cdn-image.yucrm.cn/images/yuqiyunzhou/customer/empty.png`"
            />
            <stepBox />
          </div>
          <div
            class="filter-content-right-box-group"
            v-for="(item, index) in dataListSelect"
            @click="chooseGroup(index)"
            :class="[
              {
                'filter-content-right-box-group-item__active':
                  index == groupIndex,
              },
              'filter-content-right-box-group-item',
            ]"
            :key="index"
          >
            <div
              class="filter-content-right-box-group-item__hover"
              v-if="index != 0"
            >
              <div
                :class="{ check: item.operatorType == 0 }"
                @click.stop="operatorChange(item, 0)"
              >
                <img
                  :src="`${globalCdn}/customer/jj.png`"
                  v-if="item.operatorType == 0"
                />
                <img :src="`${globalCdn}/customer/jj_n.png`" v-else />
                <span>交</span>
              </div>
              <div
                :class="{ check2: item.operatorType == 1 }"
                @click.stop="operatorChange(item, 1)"
              >
                <img
                  :src="`${globalCdn}/customer/bj.png`"
                  v-if="item.operatorType == 1"
                />
                <img :src="`${globalCdn}/customer/bj_n.png`" v-else />
                <span>并</span>
              </div>
              <div
                :class="{ check3: item.operatorType == 2 }"
                @click.stop="operatorChange(item, 2)"
              >
                <img
                  :src="`${globalCdn}/customer/result_e.png`"
                  v-if="item.operatorType == 2"
                />
                <img :src="`${globalCdn}/customer/result.png`" v-else />
                <span>差</span>
              </div>
            </div>
            <div class="filter-content-right-box-group-item__top">
              <span>{{ getGroupName(index) }}</span>
              <el-radio v-model="item.singleType" :label="0">交</el-radio>
              <el-radio v-model="item.singleType" :label="1">并</el-radio>
              <img
                :src="`${globalCdn}/customer/close_icon.png`"
                @click.stop="delDialogShow(index)"
              />
            </div>
            <div
              class="filter-content-right-box-group-item-sub"
              v-for="(label, idx) in item.children"
              :key="'label' + idx"
            >
              <template v-if="filterCategory(label.labelMeaning)">
                <div class="attr-content-item">
                  <div class="title-line">
                    <span>
                      {{ label.labelMeaning }}
                      <el-popover placement="right" trigger="hover">
                        <div v-if="label.labelDisplayType == 1">
                          {{ label.labelExplain | labelExplain }}
                          <span
                            style="color: red"
                            v-if="label.labelExplain.indexOf('</span>') != -1"
                            >（注：workday工作日，restday休息日）</span
                          >
                        </div>
                        <div v-else>{{ label.labelExplain }}</div>
                        <img
                          slot="reference"
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                          style="
                            width: 14px;
                            height: 14px;
                            vertical-align: middle;
                            cursor: pointer;
                            margin-top: -2px;
                          "
                        />
                      </el-popover>
                    </span>
                    <div class="handle">
                      <el-popover
                        placement="bottom"
                        width="500"
                        trigger="hover"
                      >
                        <jd-button type="blueText" slot="reference">
                          <!-- <i class="el-icon-document"></i> -->
                          运营助手
                        </jd-button>
                        <div class="popoverWrap">
                          <div class="popoverItem">
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/popover_label1.png"
                              class="icon"
                            />
                            <div class="desc">
                              <span>标签定义</span>
                              <div>
                                {{ label.labelDefinition }}
                              </div>
                            </div>
                          </div>
                          <div class="popoverItem">
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/popover_label2.png"
                              class="icon"
                            />
                            <div class="desc">
                              <span>运营建议</span>
                              <div>
                                {{ label.labelSuggestion }}
                              </div>
                            </div>
                          </div>
                          <div class="popoverItem">
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/popover_label3.png"
                              class="icon"
                            />
                            <div class="desc">
                              <span>时间范围</span>
                              <span>{{ label.labelSelectRange }}</span>
                            </div>
                          </div>
                        </div>
                      </el-popover>
                      <jd-button
                        type="blueText"
                        @click="delLabel(label, item, index, idx)"
                        class="ml12"
                        >删除</jd-button
                      >
                      <!-- <span class="delTxt" @click="delLabel(label, item, labelItem)"><i class="el-icon-delete"/></span> -->
                    </div>
                  </div>
                  <!-- 类型0 单选 radio  -->
                  <div
                    class="content radio-content"
                    v-if="label.labelDisplayType == 0"
                  >
                    <el-radio
                      v-for="(checkItem, checkIndex) in label.enumValues"
                      v-model="label.valueData.value"
                      :key="checkIndex"
                      :label="checkItem.realValue"
                      >{{ checkItem.fieldValue }}</el-radio
                    >
                  </div>
                  <!-- 类型10 生日-->
                  <div
                    class="content time-range"
                    v-if="label.labelDisplayType == 10"
                  >
                    <div class="birth-input">
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.startMonth"
                        :maxlength="2"
                      ></el-input>
                      <span> 月 - </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.startDay"
                        :maxlength="2"
                      ></el-input>
                      <span> 日 至 </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.endMonth"
                        :maxlength="2"
                      ></el-input>
                      <span> 月 - </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.endDay"
                        :maxlength="2"
                      ></el-input>
                      <span> 日</span>
                    </div>
                  </div>
                  <!-- 类型1 多选 checkbox -->
                  <div
                    class="content radio-content"
                    v-if="label.labelDisplayType == 1"
                  >
                    <!-- 其他类型按照原来逻辑，会员入会渠道走自定义弹窗逻辑 -->
                    <template
                      v-if="label.labelExplain.indexOf('会员开卡的渠道') == -1"
                    >
                      <el-checkbox-group
                        @change="switchAllSelect(label)"
                        style="display: inline-block; margin-right: 20px"
                        v-if="label.labelName == 'opdata_shop_member_channel'"
                        v-model="allSelectMembel"
                      >
                        <el-checkbox label="-1">全选</el-checkbox>
                      </el-checkbox-group>
                      <el-checkbox-group
                        :style="{
                          display:
                            label.labelName == 'opdata_shop_member_channel'
                              ? 'inline'
                              : 'block',
                        }"
                        v-model="label.valueData.checkValue"
                        @change="switchAllSecletStatus(label)"
                      >
                        <el-checkbox
                          v-for="(checkItem, checkIndex) in label.enumValues"
                          :key="checkIndex"
                          :label="checkItem.realValue"
                          >{{ checkItem.fieldValue }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </template>
                    <!-- 会员等级 -->
                    <template v-if="label.labelName == 'crm_member_level'">
                      <span class="label-style-box">会员等级：</span>
                      <el-checkbox-group
                        v-model="label.valueData.checkValue"
                        style="margin-top: 10px"
                      >
                        <el-checkbox
                          v-for="item in memberLevels"
                          :key="item.venderId"
                          :label="item.customerLevel"
                        >
                          {{ item.customerLevelName }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                
                  </div>
                  <!-- 类型3 区间范围选择器 -->
                  <div
                    class="content area-select"
                    v-if="label.labelDisplayType == 3"
                  >
                    <div>
                      <el-select
                        @change="rangeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != -1"
                        placeholder="起"
                        v-model="label.valueData.minValue"
                      ></el-input>
                      <span
                        v-if="label.valueData.rangeType == 0"
                        class="to-text"
                        >至</span
                      >
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != 1"
                        placeholder="至"
                        v-model="label.valueData.maxValue"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 类型7 选择省市 -->
                  <div
                    class="content select-city-box"
                    v-if="label.labelDisplayType == 7"
                  >
                    <el-button @click="handleSelectCity(index, labelIndex, idx)"
                      >选择省市（<span class="common-count-color">{{
                        provinces && provinces.length
                      }}</span>
                      ）</el-button
                    >
                  </div>
                  <!-- 类型5 指定商品 指定sku -->
                  <div
                    class="content goods-sku-box"
                    v-if="label.labelDisplayType == 5"
                  >
                    <el-radio :label="0" v-model="label.valueData.skuType">
                      <span>指定商品</span>
                      <jd-button
                        @click="showSelectGoods(index, idx)"
                        :disabled="label.valueData.skuType != 0"
                      >
                        <div class="flexc">
                          选择商品（
                          <div class="common-count-color">
                            {{ label.valueData.goodsList.length }}
                          </div>
                          ）
                        </div>
                      </jd-button>
                    </el-radio>
                    <el-radio :label="1" v-model="label.valueData.skuType">
                      <span>指定sku</span>
                      <el-input
                        type="text"
                        v-model.trim="label.valueData.value"
                        @input="limitSkuId(index, labelIndex, idx)"
                        placeholder="多个sku请用英文逗号隔开"
                      ></el-input>
                    </el-radio>
                  </div>
                  <!-- 类型2 滑块组件 取值 -->
                  <div
                    class="content slider"
                    v-if="label.labelDisplayType == 2"
                  >
                    <el-slider
                      v-model="label.valueData.slideValue"
                      show-input
                    ></el-slider>
                  </div>
                  <!-- 类型6  商品类目-->
                  <div
                    class="content slider"
                    v-if="label.labelDisplayType == 6"
                  >
                    <el-button
                      style="width: 120px"
                      @click="
                        showCategoryDialog(
                          index,
                          labelIndex,
                          idx,
                          label.valueData.value,
                        )
                      "
                      >选择类目（<span class="common-count-color">{{
                        label.valueData.value.length
                      }}</span
                      >）</el-button
                    >
                  </div>
                  <!-- 类型4 时间范围选择器 -->
                  <div
                    class="content time-range"
                    v-show="
                      label.labelDisplayType == 4 ||
                      label.labelName == 'crm_order_refund_success_time'
                    "
                  >
                    <div>
                      <el-select
                        @change="timeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                        style="width: 100px; margin-right: 20px"
                      >
                        <template
                          v-if="
                            label.labelName == 'opdata_shop_ord_date' ||
                            label.labelName ==
                              'opdata_shop_presale_last1year_time' ||
                            label.labelName ==
                              'opdata_shop_giftcard_rechargedates'
                          "
                        >
                          <el-option
                            v-for="(item, index) in areaSelectTime2"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </template>
                        <el-option
                          v-else
                          v-for="(item, index) in areaSelectTime"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time global-select-time__border"
                        v-if="label.valueData.rangeType == 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          @change="limitTimeRange(label)"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'start'
                            ]
                          "
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          @change="limitTimeRange(label)"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'end'
                            ]
                          "
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearTime(index, labelIndex, idx)"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 2"
                        prefix-icon="no_icon"
                        v-model="label.valueData.maxTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 1"
                        prefix-icon="no_icon"
                        v-model="label.valueData.minTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 日期 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 4"
                        type="dates"
                        class="datePicker"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        v-model="label.valueData.value"
                        placeholder="选择一个或多个日期"
                      >
                      </el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="label.valueData.rangeType == 3">
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          @blur="
                            timeCheck(label, label.valueData.minTime, $event)
                          "
                          placeholder="天"
                          v-model="label.valueData.minTime"
                          style="width: 125px"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          @blur="
                            timeCheck(label, label.valueData.maxTime, $event)
                          "
                          placeholder="天"
                          style="width: 125px"
                          v-model="label.valueData.maxTime"
                        ></el-input>
                      </span>
                    </div>
                  </div>
                  <!--类型8 直播输入框 -->
                  <div
                    style="padding-left: 20px"
                    class="content slider"
                    v-if="label.labelDisplayType == 8"
                  >
                    <el-input
                      style="width: 280px"
                      v-model="label.valueData.value"
                      placeholder="请输入直播ID，多个id请用英文逗号隔开"
                    ></el-input>
                  </div>
                  <!-- 类型9 京获客活动双下拉框 -->
                  <div
                    class="content time-range"
                    v-if="label.labelDisplayType == 9"
                  >
                    <select-activity
                      :form.sync="label.valueData"
                      :options="activityOptionsObj[label.labelName]"
                    ></select-activity>
                  </div>
                  <!-- 互动标签 - 参与指定活动 -->
                  <div
                    class="content time-range"
                    v-if="label.labelName == 'hd_join_select'"
                  >
                    <div>
                      <span class="label-style-box">参与时间：</span>
                      <el-select
                        @change="timeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                        style="width: 100px; margin-right: 20px"
                      >
                        <el-option label="不限" value=""></el-option>
                        <el-option
                          v-for="(item, index) in areaSelectTime"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time global-select-time__border"
                        v-if="label.valueData.rangeType === 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'start'
                            ]
                          "
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'end'
                            ]
                          "
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearTime(index, labelIndex, idx)"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 2"
                        prefix-icon="no_icon"
                        v-model="label.valueData.maxTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 1"
                        prefix-icon="no_icon"
                        v-model="label.valueData.minTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 日期 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 4"
                        type="dates"
                        class="datePicker"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        v-model="label.valueData.value"
                        placeholder="选择一个或多个日期"
                      >
                      </el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="label.valueData.rangeType == 3">
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          v-model="label.valueData.minTime"
                          style="width: 125px"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          style="width: 125px"
                          v-model="label.valueData.maxTime"
                        ></el-input>
                      </span>
                    </div>
                    <div style="margin-top: 14px">
                      <span class="label-style-box">指定活动：</span>
                      <select-activity
                        :form.sync="label.valueData"
                        :options="activityOptionsObj.hd_join_select"
                        style="display: inline-block"
                      ></select-activity>
                    </div>
                    <div class="area-select">
                      <span class="label-style-box">参与次数：</span>
                      <el-select
                        @change="joinRangeTypeChange(label)"
                        v-model="label.valueData.joinRangeType"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        v-if="label.valueData.joinRangeType != -1"
                        placeholder="起"
                        v-model="label.valueData.join_start_value"
                      ></el-input>
                      <span
                        v-if="label.valueData.joinRangeType == 0"
                        class="to-text"
                        >至</span
                      >
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        v-if="label.valueData.joinRangeType != 1"
                        placeholder="至"
                        v-model="label.valueData.join_end_value"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 互动标签 - 生日时间 -->
                  <div
                    class="content time-range"
                    v-if="label.labelName == 'hd_birth_time'"
                  >
                    <div class="birth-input">
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.startMonth"
                        :maxlength="2"
                      ></el-input>
                      <span> 月 - </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.startDay"
                        :maxlength="2"
                      ></el-input>
                      <span> 日 至 </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.endMonth"
                        :maxlength="2"
                      ></el-input>
                      <span> 月 - </span>
                      <el-input
                        oninput="value=value.replace(/\D/g,'')"
                        placeholder=""
                        v-model="label.valueData.endDay"
                        :maxlength="2"
                      ></el-input>
                      <span> 日</span>
                    </div>
                  </div>
                  <!-- 联合营销 单下拉框 -->
                  <div
                    class="content select"
                    v-if="label.labelDisplayType == 11"
                  >
                    <el-select
                      v-model="label.valueData.activityId"
                      style="margin-top: 14px"
                    >
                      <el-option
                        v-for="(sel, index) in marketOptions[label.labelName]"
                        :key="index"
                        :label="sel.activityName"
                        :value="sel.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <!-- 互动活动参会列表 -->
                  <div
                    class="content time-range"
                    v-if="label.labelName == 'opdata_shop_interact_activitys'"
                  >
                    <select-activity-checks
                      :form.sync="label.valueData"
                      :options="activityOptionsObj['hd_join_select']"
                    ></select-activity-checks>
                  </div>
                  <!-- 评价状态 -->
                  <div
                    class="content radio-content"
                    v-if="label.labelName == 'crm_comment_status'"
                  >
                    <div>
                      <span class="label-style-box">评价状态：</span>
                      <el-radio
                        v-model="label.valueData.commentStatus"
                        :label="1"
                        >已评价</el-radio
                      >
                      <el-radio
                        v-model="label.valueData.commentStatus"
                        :label="0"
                        >未评价</el-radio
                      >
                    </div>
                    <div v-if="label.valueData.commentStatus == 1">
                      <span class="label-style-box">评价等级：</span>
                      <el-checkbox-group
                        v-model="label.valueData.commentGrade"
                        style="display: inline"
                      >
                        <el-checkbox
                          v-for="checkItem in commentGradeOptions"
                          :key="checkItem.value"
                          :label="checkItem.value"
                          >{{ checkItem.label }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </div>
                  <!-- 买家备注 -->
                  <div
                    class="content radio-content"
                    v-if="label.labelName == 'crm_user_remark'"
                  >
                    <el-radio v-model="label.valueData.remarkType" label="0"
                      >买家无备注</el-radio
                    >
                    <el-radio v-model="label.valueData.remarkType" label="1">
                      买家有备注
                      <el-input
                        v-if="label.valueData.remarkType == 1"
                        style="width: 250px; margin-left: 5px"
                        v-model="label.valueData.remark"
                        placeholder="备注内容"
                      ></el-input>
                    </el-radio>
                  </div>
                  <!-- 卖家备注 -->
                  <div
                    class="content radio-content"
                    v-if="label.labelName == 'crm_seller_remark'"
                  >
                    <el-radio v-model="label.valueData.remarkType" label="0"
                      >卖家无备注</el-radio
                    >
                    <el-radio v-model="label.valueData.remarkType" label="1">
                      卖家有备注
                      <el-input
                        v-if="label.valueData.remarkType == 1"
                        style="width: 250px; margin-left: 5px"
                        v-model="label.valueData.remark"
                        placeholder="备注内容"
                      ></el-input>
                    </el-radio>
                  </div>
                  <!-- 预售未付尾款 -->
                  <div
                    class="content time-range"
                    v-if="
                      label.labelName == 'crm_order_pre_sell_no_pay' ||
                      label.labelName == 'crm_order_no_pay'
                    "
                  >
                    <div class="area-select">
                      <span class="label-style-box">{{
                        label.labelName == "crm_order_pre_sell_no_pay"
                          ? "定金支付时间："
                          : "下单时间："
                      }}</span>
                      <el-select
                        @change="timeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                        style="width: 100px; margin-right: 20px"
                      >
                        <el-option
                          v-for="(item, index) in areaSelectTime"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time global-select-time__border"
                        v-if="label.valueData.rangeType === 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'start'
                            ]
                          "
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'end'
                            ]
                          "
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearTime(index, labelIndex, idx)"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 2"
                        prefix-icon="no_icon"
                        v-model="label.valueData.maxTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 1"
                        prefix-icon="no_icon"
                        v-model="label.valueData.minTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 日期 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 4"
                        type="dates"
                        class="datePicker"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        v-model="label.valueData.value"
                        placeholder="选择一个或多个日期"
                      >
                      </el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="label.valueData.rangeType == 3">
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          v-model="label.valueData.minTime"
                          style="width: 125px"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          style="width: 125px"
                          v-model="label.valueData.maxTime"
                        ></el-input>
                      </span>
                    </div>
                  </div>
                  <!-- 商品购买次数 or 商品购买件数 or 订单指定购买件数-->
                  <div
                    class="content time-range"
                    v-if="
                      label.labelName == 'crm_order_sku_buy_times' ||
                      label.labelName == 'crm_order_sku_buy_total' ||
                      label.labelName == 'crm_order_single_sku_buy_total'
                    "
                  >
                    <div class="area-select">
                      <span class="label-style-box">下单时间：</span>
                      <el-radio
                        v-model="label.valueData.orderTimeStatus"
                        :label="0"
                        >不限</el-radio
                      >
                      <el-radio
                        v-model="label.valueData.orderTimeStatus"
                        :label="1"
                      >
                        <span>指定时间：</span>
                        <el-select
                          @change="timeTypeChange(label)"
                          v-model="label.valueData.timeRangeType"
                          style="width: 100px; margin-right: 20px"
                        >
                          <el-option
                            v-for="(item, index) in areaSelectTime"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 区间时间 -->
                        <div
                          class="my_select_time global-select-time__border"
                          v-if="label.valueData.timeRangeType === 0"
                        >
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.__pickerKey + 'start'
                              ]
                            "
                            value-format="yyyy-MM-dd"
                            style="width: 120px"
                            class="time1"
                            :clearable="false"
                          ></el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.maxTime"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.__pickerKey + 'end'
                              ]
                            "
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 135px"
                            class="time2"
                            :clearable="false"
                          ></el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            @click="clearTime(index, labelIndex, idx)"
                          ></i>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                            alt
                            class="date_icon2"
                          />
                        </div>
                        <!-- 小于时间 -->
                        <el-date-picker
                          v-if="label.valueData.timeRangeType == 2"
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions(label)"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 大于时间 -->
                        <el-date-picker
                          v-if="label.valueData.timeRangeType == 1"
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions(label)"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 日期 -->
                        <el-date-picker
                          v-if="label.valueData.timeRangeType == 4"
                          type="dates"
                          class="datePicker"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions(label)"
                          v-model="label.valueData.value"
                          placeholder="选择一个或多个日期"
                        >
                        </el-date-picker>
                        <!-- 相对时间 -->
                        <span v-if="label.valueData.timeRangeType == 3">
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            v-model="label.valueData.minTime"
                            style="width: 125px"
                          ></el-input>
                          <span style="margin: 0 8px" class="to-text">至</span>
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            style="width: 125px"
                            v-model="label.valueData.maxTime"
                          ></el-input>
                        </span>
                      </el-radio>
                    </div>
                    <div class="item-wrap">
                      <span class="label-style-box">选择商品：</span>
                      <el-radio :label="0" v-model="label.valueData.skuType">
                        <span>选择sku </span>
                        <jd-button
                          @click="showSelectGoods(index, idx)"
                          :disabled="label.valueData.skuType != 0"
                          :style="{
                            color:
                              label.valueData.skuType == 0
                                ? globalBG
                                : '#C0C4CC',
                          }"
                        >
                          <div class="flexc">
                            选择商品（<span class="common-count-color">{{
                              label.valueData.goodsList.length
                            }}</span>
                            ）
                          </div>
                        </jd-button>
                      </el-radio>
                      <el-radio :label="1" v-model="label.valueData.skuType">
                        <span>输入sku </span>
                        <el-input
                          type="text"
                          v-model.trim="label.valueData.value"
                          @input="limitSkuId(index, labelIndex, idx)"
                          placeholder="多个sku请用英文逗号隔开"
                        ></el-input>
                      </el-radio>
                    </div>
                    <div class="area-select">
                      <span
                        class="label-style-box"
                        v-if="label.labelName == 'crm_order_sku_buy_times'"
                        >购买次数：</span
                      >
                      <span class="label-style-box" v-else>购买件数：</span>
                      <el-select
                        @change="rangeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != -1"
                        placeholder="起"
                        v-model="label.valueData.minValue"
                      ></el-input>
                      <span
                        v-if="label.valueData.rangeType == 0"
                        class="to-text"
                        >至</span
                      >
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != 1"
                        placeholder="至"
                        v-model="label.valueData.maxValue"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 单品最近一次购买时间 -->
                  <div
                    class="content time-range"
                    v-if="label.labelName == 'crm_order_single_sku_buy_last'"
                  >
                    <div class="item-wrap">
                      <span class="label-style-box">选择商品：</span>
                      <el-radio :label="0" v-model="label.valueData.skuType">
                        <span>选择sku</span>
                        <jd-button
                          @click="showSelectGoods(index, idx)"
                          :disabled="label.valueData.skuType != 0"
                          :style="{
                            color:
                              label.valueData.skuType == 0
                                ? globalBG
                                : '#C0C4CC',
                          }"
                        >
                          <div class="flexc">
                            选择商品（<span class="common-count-color">{{
                              label.valueData.goodsList.length
                            }}</span>
                            ）
                          </div>
                        </jd-button>
                      </el-radio>
                      <el-radio :label="1" v-model="label.valueData.skuType">
                        <span>输入sku </span>
                        <el-input
                          type="text"
                          v-model.trim="label.valueData.value"
                          @input="limitSkuId(index, labelIndex, idx)"
                          placeholder="多个sku请用英文逗号隔开"
                        ></el-input>
                      </el-radio>
                    </div>
                    <div class="area-select">
                      <span class="label-style-box">最近付款下单时间：</span>
                      <el-select
                        @change="timeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                        style="width: 100px; margin-right: 20px"
                      >
                        <el-option
                          v-for="(item, index) in areaSelectTime"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time global-select-time__border"
                        v-if="label.valueData.rangeType === 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'start'
                            ]
                          "
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'end'
                            ]
                          "
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearTime(index, labelIndex, idx)"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 2"
                        prefix-icon="no_icon"
                        v-model="label.valueData.maxTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 1"
                        prefix-icon="no_icon"
                        v-model="label.valueData.minTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 日期 -->
                      <el-date-picker
                        v-if="label.valueData.rangeType == 4"
                        type="dates"
                        class="datePicker"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        v-model="label.valueData.value"
                        placeholder="选择一个或多个日期"
                      >
                      </el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="label.valueData.rangeType == 3">
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          v-model="label.valueData.minTime"
                          style="width: 125px"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          style="width: 125px"
                          v-model="label.valueData.maxTime"
                        ></el-input>
                      </span>
                    </div>
                  </div>
                  <!-- 商品件数 -->
                  <div
                    class="content area-select"
                    v-if="
                      label.labelName == 'crm_order_sku_total' ||
                      label.labelName == 'crm_order_refund_success_num'
                    "
                  >
                    <div>
                      <el-select
                        @change="rangeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != -1"
                        placeholder="起"
                        v-model="label.valueData.minValue"
                      ></el-input>
                      <span
                        v-if="label.valueData.rangeType == 0"
                        class="to-text"
                        >至</span
                      >
                      <!-- v-only-number -->
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-if="label.valueData.rangeType != 1"
                        placeholder="至"
                        v-model="label.valueData.maxValue"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 客户属性 -->
                  <div
                    class="content area-select"
                    v-if="label.labelName == 'dd_customer_attr'"
                  >
                    <div v-for="(item, index) in ddLabelList" :key="index">
                      <div
                        class="flex margin-t16"
                        v-if="item.attributeType == 1"
                      >
                        <div class="flex-lebel label-style-box">
                          <span>{{ item.name }}：</span>
                        </div>
                        <div class="flex-content">
                          <span class="flex-content-r8"
                            >{{ item.name }}内容</span
                          >
                          <el-select v-model="item.textType">
                            <el-option
                              v-for="(item, index) in ddRemarkLabel"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <el-input
                            v-model="item.value"
                            class="flex-content-search"
                            placeholder="输入关键词，多个之间用英文逗号隔开"
                          ></el-input>
                        </div>
                      </div>
                      <div
                        class="flex margin-t16"
                        v-else-if="item.attributeType == 2"
                      >
                        <div class="flex-lebel label-style-box">
                          <span>{{ item.name }}：</span>
                        </div>
                        <el-radio-group v-model="item.radio">
                          <el-radio
                            :label="item"
                            v-for="(item, index) in item.attributeOption.split(
                              ',',
                            )"
                            :key="item + index"
                          ></el-radio>
                        </el-radio-group>
                      </div>
                      <div
                        class="flex margin-t16"
                        v-else-if="item.attributeType == 3"
                      >
                        <div class="flex-lebel label-style-box">
                          <span>{{ item.name }}：</span>
                        </div>
                        <el-checkbox-group
                          v-model="item.checkbox"
                          v-if="item.type == 0"
                        >
                          <el-checkbox
                            :label="item"
                            v-for="(item, index) in item.attributeOption.split(
                              ',',
                            )"
                            :key="item + index"
                          >
                            {{ item == 1 ? "男" : item == 2 ? "女" : "未知" }}
                          </el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-model="item.checkbox" v-else>
                          <el-checkbox
                            :label="item"
                            v-for="(item, index) in item.attributeOption.split(
                              ',',
                            )"
                            :key="item + index"
                          ></el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div
                        class="flex margin-t16"
                        v-else-if="item.attributeType == 4"
                      >
                        <div class="flex-lebel label-style-box">
                          <span>{{ item.name }}：</span>
                        </div>
                        <el-select v-model="item.select">
                          <el-option
                            v-for="(item, index) in item.attributeOption.split(
                              ',',
                            )"
                            :key="item + index"
                            :label="item.item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </div>
                      <div
                        class="flex margin-t16"
                        v-else-if="item.attributeType == 5"
                      >
                        <div class="flex-lebel label-style-box">
                          <span>{{ item.name }}：</span>
                        </div>
                        <div class="flex-content" v-if="item.type == 1">
                          <el-select
                            @change="timeTypeChangeDd(item)"
                            v-model="item.rangeType"
                            style="width: 100px; margin-right: 20px"
                          >
                            <el-option
                              v-for="(item, index) in areaSelectTime"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <div
                            class="my_select_time global-select-time__border"
                            v-if="item.rangeType == 0"
                          >
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="item.minTime"
                              type="date"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              :picker-options="ddTimeStart(item)"
                              value-format="yyyy-MM-dd"
                              style="width: 120px"
                              class="time1"
                              :clearable="false"
                            ></el-date-picker>
                            <div class="time_to_text">至</div>
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="item.maxTime"
                              type="date"
                              :picker-options="ddTimeEnd(item)"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              style="width: 135px"
                              class="time2"
                              :clearable="false"
                            ></el-date-picker>
                            <i
                              class="el-icon-circle-close date_icon1"
                              @click="clearDdTime(item)"
                            ></i>
                            <img
                              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                              alt
                              class="date_icon2"
                            />
                          </div>
                          <!-- 小于时间 -->
                          <el-date-picker
                            v-if="item.rangeType == 2"
                            prefix-icon="no_icon"
                            v-model="item.maxTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions({})"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 大于时间 -->
                          <el-date-picker
                            v-if="item.rangeType == 1"
                            prefix-icon="no_icon"
                            v-model="item.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions({})"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 相对时间 -->
                          <span v-if="item.rangeType == 3">
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              placeholder="天"
                              v-model="item.minTime"
                              style="width: 125px"
                            ></el-input>
                            <span style="margin: 0 8px" class="to-text"
                              >至</span
                            >
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              style="width: 125px"
                              v-model="item.maxTime"
                            ></el-input>
                          </span>
                        </div>
                        <div class="flex-content" v-else>
                          <el-input
                            v-model="item.startMonth"
                            @input="ddTimeMonthInput(item, 'startMonth')"
                          ></el-input>
                          <span class="flex-content-label">月-</span>
                          <el-input
                            v-model="item.startDay"
                            @input="ddTimeDayInput(item, 'startDay')"
                          ></el-input>
                          <span class="flex-content-label">日 至</span>
                          <el-input
                            v-model="item.endMonth"
                            @input="ddTimeMonthInput(item, 'endMonth')"
                          ></el-input>
                          <span class="flex-content-label">月-</span>
                          <el-input
                            v-model="item.endDay"
                            @input="ddTimeDayInput(item, 'endDay')"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 自定义标签 -->
                  <div
                    class="content area-select"
                    v-if="label.labelName == 'dong_label_ids'"
                  >
                    <el-checkbox-group
                      v-model="ddAttrListValue"
                      class="custom-tag-checkbox"
                    >
                      <div
                        :class="['flex', { 'margin-t16': index != 0 }]"
                        v-for="(item, index) in ddAttrList"
                        :key="item.classifyName + index"
                      >
                        <div class="flex-lebel">
                          <span>{{ item.classifyName }}：</span>
                        </div>
                        <el-checkbox
                          :label="sub.id"
                          v-for="sub in item.labels"
                          :key="sub.id"
                          >{{ sub.name }}</el-checkbox
                        >
                      </div>
                    </el-checkbox-group>
                  </div>
                  <!-- 付款订单数 || 客单价 -->
                  <div
                    class="content area-select"
                    v-if="
                      label.labelName == 'crm_pay_order_count' ||
                      label.labelName == 'crm_order_customer_price'
                    "
                  >
                    <div class="area-select">
                      <span class="label-style-box">付款时间：</span>
                      <el-radio
                        v-model="label.valueData.orderTimeStatus"
                        :label="0"
                        >不限</el-radio
                      >
                      <el-radio
                        v-model="label.valueData.orderTimeStatus"
                        :label="1"
                      >
                        <span class="label-style-box">指定时间：</span>
                        <el-select
                          @change="timeTypeChange(label)"
                          v-model="label.valueData.timeRangeType"
                          style="width: 100px; margin-right: 20px"
                        >
                          <el-option
                            v-for="(item, index) in areaSelectTime4"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <!-- 区间时间 -->
                        <div
                          class="my_select_time global-select-time__border"
                          v-if="label.valueData.timeRangeType === 0"
                        >
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.__pickerKey + 'start'
                              ]
                            "
                            value-format="yyyy-MM-dd"
                            style="width: 120px"
                            class="time1"
                            :clearable="false"
                          ></el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="label.valueData.maxTime"
                            :picker-options="
                              pickerOptionsList[
                                'pickerOptions' + label.__pickerKey + 'end'
                              ]
                            "
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 135px"
                            class="time2"
                            :clearable="false"
                          ></el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            @click="clearTime(index, labelIndex, idx)"
                          ></i>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                            alt
                            class="date_icon2"
                          />
                        </div>
                        <!-- 小于时间 -->
                        <el-date-picker
                          v-if="label.valueData.timeRangeType == 2"
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions(label)"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 大于时间 -->
                        <el-date-picker
                          v-if="label.valueData.timeRangeType == 1"
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions(label)"
                          value-format="yyyy-MM-dd"
                          style="width: 240px"
                          :clearable="false"
                        ></el-date-picker>
                        <!-- 相对时间 -->
                        <span v-if="label.valueData.timeRangeType == 3">
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            v-model="label.valueData.minTime"
                            style="width: 125px"
                          ></el-input>
                          <span style="margin: 0 8px" class="to-text">至</span>
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            placeholder="天"
                            style="width: 125px"
                            v-model="label.valueData.maxTime"
                          ></el-input>
                        </span>
                      </el-radio>
                    </div>
                    <div class="area-select">
                      <span class="label-style-box">{{
                        label.labelName == "crm_pay_order_count"
                          ? "付款订单数："
                          : "客单价："
                      }}</span>
                      <el-select
                        @change="rangeTypeChange(label)"
                        v-model="label.valueData.rangeType"
                      >
                        <el-option
                          v-for="(item, index) in areaSelect"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- v-only-number -->
                      <el-input
                        @input="
                          label.valueData.minValue = getNumberData(
                            1,
                            $event,
                            label.labelName == 'crm_pay_order_count' ? 0 : 1,
                            0,
                            999999,
                          )
                        "
                        v-if="label.valueData.rangeType != -1"
                        placeholder="起"
                        v-model="label.valueData.minValue"
                      ></el-input>
                      <span
                        v-if="label.valueData.rangeType == 0"
                        class="to-text"
                        >至</span
                      >
                      <!-- v-only-number -->
                      <el-input
                        @input="
                          label.valueData.maxValue = getNumberData(
                            1,
                            $event,
                            label.labelName == 'crm_pay_order_count' ? 0 : 1,
                            0,
                            999999,
                          )
                        "
                        v-if="label.valueData.rangeType != 1"
                        placeholder="止"
                        v-model="label.valueData.maxValue"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 会员开卡时间 -->
                  <div
                    class="content area-select"
                    v-if="label.labelName == 'crm_open_card_time'"
                  >
                    <div class="area-select">
                      <span class="label-style-box">开卡时间：</span>
                      <el-select
                        @change="timeTypeChange(label)"
                        v-model="label.valueData.timeRangeType"
                        style="width: 100px; margin-right: 20px"
                      >
                        <el-option
                          v-for="(item, index) in areaSelectTime4"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!-- 区间时间 -->
                      <div
                        class="my_select_time global-select-time__border"
                        v-if="label.valueData.timeRangeType === 0"
                      >
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.minTime"
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'start'
                            ]
                          "
                          value-format="yyyy-MM-dd"
                          style="width: 120px"
                          class="time1"
                          :clearable="false"
                        ></el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="label.valueData.maxTime"
                          :picker-options="
                            pickerOptionsList[
                              'pickerOptions' + label.__pickerKey + 'end'
                            ]
                          "
                          type="date"
                          :placeholder="'选择日期时间'"
                          size="small"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 135px"
                          class="time2"
                          :clearable="false"
                        ></el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearTime(index, labelIndex, idx)"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt
                          class="date_icon2"
                        />
                      </div>
                      <!-- 小于时间 -->
                      <el-date-picker
                        v-if="label.valueData.timeRangeType == 2"
                        prefix-icon="no_icon"
                        v-model="label.valueData.maxTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 大于时间 -->
                      <el-date-picker
                        v-if="label.valueData.timeRangeType == 1"
                        prefix-icon="no_icon"
                        v-model="label.valueData.minTime"
                        type="date"
                        :placeholder="'选择日期时间'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions(label)"
                        value-format="yyyy-MM-dd"
                        style="width: 240px"
                        :clearable="false"
                      ></el-date-picker>
                      <!-- 相对时间 -->
                      <span v-if="label.valueData.timeRangeType == 3">
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          v-model="label.valueData.minTime"
                          style="width: 125px"
                        ></el-input>
                        <span style="margin: 0 8px" class="to-text">至</span>
                        <el-input
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder="天"
                          style="width: 125px"
                          v-model="label.valueData.maxTime"
                        ></el-input>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="filter-content-right-box-add"
              v-if="dataListSelect.length > 0 && dataListSelect.length < 3"
            >
              <jd-button type="default" @click="addGroup">{{
                `添加小组（${dataListSelect.length}/3）`
              }}</jd-button>
            </div>
          </div>
        </div>
        <div class="footer-save" v-if="!isDisabled">
          <div>
            <jd-button
              type="blueLine"
              :disabled="compLoading"
              @click="$parent.handlePeopleComputed()"
              >点击计算</jd-button
            >
            <span class="people-count ml8">预估人数：</span>
            <i class="el-icon-loading" v-if="compLoading"></i>
            <span class="people-count people-color" v-else>{{
              $parent.population
            }}</span>
            <span class="people-count ml2">人</span>
          </div>
          <jd-button type="blue" @click="$parent.handleSave()">保存</jd-button>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="venderType ? true : false"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
    <!-- 自定义城市弹窗 -->
    <city-popover
      v-model="cityShow"
      @on-change="getLocation"
      :checkedList="provinces"
    ></city-popover>
    <!-- 商品类目 -->
    <goods-category-dialog
      @on-close="closeCategory"
      v-model="goodsCategoryDialog"
      :goodsClass="goodsClass"
    ></goods-category-dialog>
    <!-- 品类标签 商品类目 -->
    <goods-category-dialog
      @on-close="handleCategory"
      :goodsSel="goodsSel"
      v-model="CategoryDialog"
      :goodsClass="goodsClass"
    ></goods-category-dialog>
    <goods-pinlei-dialog
      @on-close="handleBrantCategory"
      v-model="pinpaiCategory"
      :brandsList="brandsList"
    ></goods-pinlei-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CityPopover from "@/views/manage/components/city-popover";
import SelectActivity from "@/components/select-activity";
import SelectActivityChecks from "@/components/select-activity-checks";
import goodsCategoryDialog from "./goods-category-dialog";
import goodsPinleiDialog from "./goods-pinlei-dialog";
import SelectGoods from "@/components/selectGoodsMonitor";
import {
  getLabel,
  addCustomQdId,
  delCustomQdId,
  getCustomQdIdList,
  activityList,
  getDdLabel,
  getDdAttr,
} from "@/api/manage/memberLabelController";
import {
  advancedTags,
  getLastUsed,
  getLastUsedCustom,
  lastUsedSave,
  lastUsedDelete,
} from "@/api/memberCrowd";
import { querymemberLevels } from "@/api/mutualMember/mutual";
import { getSeller } from "@/api/sellerController";
import stepBox from "@/components/stepBox.vue";
import { useInteractActivityTypeList,useInteractOpenCardTypeList,useInteractJoinActivityTypeList} from "@/common/hook";
const interactActivityTypeList = useInteractActivityTypeList();
const interactOpenCardTypeList = useInteractOpenCardTypeList();
const interactJoinActivityTypeList = useInteractJoinActivityTypeList();
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editData: {
      // 修改
      type: Object,
    },
    classifyType: {
      // 人群分类
      type: Number | String,
      default: 1,
    },
    classifyId: {
      // 分组ID
      type: Number | String,
      default: "",
    },
    compLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isShowLeft: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    CityPopover,
    goodsCategoryDialog,
    SelectGoods,
    goodsPinleiDialog,
    SelectActivity,
    SelectActivityChecks,
    stepBox,
  },
  filters: {
    labelExplain(value) {
      var result = value;
      if (value.indexOf("</span>") != -1) {
        // result = "根据客户近半年非大促期间的客户下单数据分析计算出偏好（注：workday工作日，restday休息日）";
        return result.split("<span")[0];
      }
      return result;
    },
  },
  data() {
    return {
      dataListSelect: [],
      globalCdn: "https://cdn-image.yucrm.cn/images/yuqiyunzhou",
      groupIndex: null,
      isLoading: false,
      showVisibale: false,
      shake: false, // 节流
      isOrderHd: false, //京获客资格
      storageOfficialIdList: [], // 缓存已选的官方渠道Id列表
      storageOfficialId: [], // 缓存已选的官方渠道Id
      storageCustomId: [], // 缓存已选的手动录入渠道Id
      isCommonShow: true, // 常用标签显示状态
      loading: false,
      loading1: false,
      mangeQd: true, // 管理渠道
      batchDelId: [], // 批量删除id列表
      checkOfficialIdList: [], // 选中的官方渠道id
      checkedCustomId: [], // 已选自定义渠道id
      allSelectCustomId: [], // 自定义渠道id全选
      allSelectCustomIdDel: [], // 自定义渠道id全选-删除
      memberLevels: [], // 会员等级
      customIdList: ["全选"], // 自定义渠道id列表
      tabIndex: "1", // 渠道弹窗tab下标
      manualId: "", // 手动录入id
      qdVisible: false, // 选择渠道弹窗
      labels: 0,
      fasle: false,

      dataList: [],
      isNewNum: 0,
      isSaveLocation: false,
      isShowNew: true,
      areaSelect: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: -1,
        },
      ],
      areaSelectTime: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: 2,
        },
        {
          label: "相对时间",
          value: 3,
        },
      ],
      areaSelectTime4: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "晚于等于",
          value: 1,
        },
        {
          label: "早于等于",
          value: 2,
        },
        {
          label: "相对时间",
          value: 3,
        },
      ],
      areaSelectTime2: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "日期",
          value: 4,
        },
      ],
      areaSelectTime3: [
        {
          label: "日期",
          value: 4,
        },
      ],
      ddRemarkLabel: [
        {
          label: "包含",
          value: 1,
        },
        {
          label: "不包含",
          value: 2,
        },
      ],
      defaultShow: true, //无内容时跳出提示图标
      valueData: {
        minValue: "",
        maxValue: "",
        rangeType: 0, // 区间范围的值 0: 区间 1:大于 -1：小于
        slideValue: 0, // 滑动组件的值
        minTime: "",
        maxTime: "",
        itemInfo: [], // 商品信息
        skuInfo: [],
        skuType: 0, // 0. 指定商品 1.指定sku
        checkValue: [], // sku的值
        value: "",
        visible: false,
        goodsList: [],
      },
      allSelectMembel: [], // 会员入会渠道标签全选
      cityShow: false,
      provinces: [],
      goodsClass: [], //商品类目
      goodsCategoryDialog: false,
      searchStatus: false, // 是否为查询状态
      searchValue: "", // 查询值
      goodsState: false,
      returnSelectGoods: [],
      selectGoodsSkuList: [],
      currentIndex: [], // 第一个值表示dataIndex, 第二个值表示labelIndex
      pickerOptionsList: {},
      pickerKeySeed: 0, // 配置项时间选择器唯一 key 的自增种子
      pickerOptions: function (obj) {
        let timeRange = obj.labelSelectRange;
        let stamp = 0;
        let dataRange = new Date();
        if (timeRange == "近90天") stamp = 91;
        if (timeRange == "近400天") stamp = 401;
        if (timeRange == "近三年") stamp = 1096;
        if (timeRange == "近1月") stamp = 31;
        if (timeRange == "近1年" || timeRange == "近一年") stamp = 366;
        if (timeRange == "近2年" || timeRange == "近两年") stamp = 731;
        if (timeRange == "历史所有") stamp = 0;
        if (stamp) {
          dataRange.setDate(dataRange.getDate() - stamp);
          dataRange = dataRange.getTime();
        }
        return {
          disabledDate: (time) => {
            if (stamp) {
              return time.getTime() > Date.now() || time.getTime() < dataRange;
            } else {
              return time.getTime() > Date.now();
            }
          },
        };
      },
      // 会员入会渠道标签的值
      memberChannel: [
        "1",
        "2,3,995,998",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "113",
        "114",
        "115",
        "116",
        "117",
        "119",
        "120",
        "121",
        "130",
        "140",
        "150",
        "201",
        "202",
        "203",
        "212,213",
        "214",
        "215",
        "216",
        "217",
        "218",
        "219",
        "220",
        "301",
        "401",
        "405",
        "411",
        "420,666",
        "430",
        "501",
        "502",
        "503",
        "504",
        "601",
        "602",
        "603",
        "701",
        "801",
        "920",
        "999",
        "1003,1004,1234",
        "1301",
        "2011",
        "3021",
        "3022",
        "4021,4022,4023,402",
        "4031,403",
        "4032",
        "4033",
        "4034",
        "4035",
        "4036",
        "4037",
        "4041,4042,404",
      ],
      allMemberChannel: [
        "1",
        "2",
        "3",
        "995",
        "998",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "113",
        "114",
        "115",
        "116",
        "117",
        "119",
        "120",
        "121",
        "130",
        "140",
        "150",
        "201",
        "202",
        "203",
        "212",
        "213",
        "214",
        "215",
        "216",
        "217",
        "218",
        "219",
        "220",
        "301",
        "401",
        "405",
        "411",
        "420",
        "666",
        "430",
        "501",
        "502",
        "503",
        "504",
        "601",
        "602",
        "603",
        "701",
        "801",
        "920",
        "999",
        "1003",
        "1004",
        "1234",
        "1301",
        "2011",
        "3021",
        "3022",
        "4021",
        "4022",
        "4023",
        "402",
        "4031",
        "403",
        "4032",
        "4033",
        "4034",
        "4035",
        "4036",
        "4037",
        "4041",
        "4042",
        "404",
      ],
      shopMemberType: "",
      // 获取隐藏标签列表
      permissionsList: [],
      CategoryDialog: false, // 弹框
      goodsIndex: 0, // 品类 下标
      goodsPerantID: -111, // 品类  一类的父ID
      goodpinpei: 0, // 判断商品类目选择第几大类
      pinleiCategory: [], //判断品类和其他类 二选一
      goodsSel: false, // 判断为店铺还是商品名称
      goodsItem: [],
      //品牌
      pinpaiCategory: false,
      brandsList: [],
      brandIndex: 0,
      advanced: ["", ""],
      leftWarpTitle: "常用标签", // 左侧查询条件
      flag1: false, // 节流状态
      throttletimer: null, // 节流定时器
      recentlyList: [], // 最近使用列表
      commonUseList: [], // 自定义设置列表
      successDaiLog: false, // 保存成功弹窗
      popoverStatus: true,
      // 互动
      activityOptionsObj: {
        hd_join_select: interactJoinActivityTypeList,
        hd_open_card:interactOpenCardTypeList,
        hd_introducing_pay: interactActivityTypeList,
        hd_introducing_trade: interactActivityTypeList,
        hd_split_user: [
          //裂变用户
          { label: "邀请开卡有礼", value: 5 },
          { label: "邀请关注有礼", value: 6 },
          { label: "裂变神券", value: 21 },
          { label: "超级裂变券", value: 31 },
        ],
      },
      // 联合营销下拉
      marketOptions: {
        // 开卡
        uinte_open_card: [],
        // 领券
        unite_get_coupon: [],
      },
      // 评价等级列表
      commentGradeOptions: [
        { label: "一星", value: "1" },
        { label: "二星", value: "2" },
        { label: "三星", value: "3" },
        { label: "四星", value: "4" },
        { label: "五星", value: "5" },
      ],
      limit: null,
      // 咚咚客服工具label
      ddLabel: {
        firstLevelCategory: "客服工具",
        data: [
          {
            secondLevelCategory: "客户信息",
            data: [
              {
                labelName: "dd_customer_attr",
                labelMeaning: "客户属性",
                labelGroup: "hd_act",
                labelDesc: "",
                labelExplain: "",
                labelDefinition: "",
                labelSuggestion: "",
              },
              {
                labelName: "dong_label_ids",
                labelMeaning: "自定义标签",
                labelGroup: "hd_act",
                labelDesc: "",
                labelExplain: "",
                labelDefinition: "",
                labelSuggestion: "",
              },
            ],
          },
        ],
      },
      ddLabelList: [
        {
          type: 0,
          name: "性别",
          tagname: "dong_sex",
          attributeType: 3,
          attributeOption: "1,2,0",
          checkbox: [],
        },
        {
          type: 0,
          name: "生日",
          tagname: "dong_birth_day",
          attributeType: 5,
          startMonth: "",
          endMonth: "",
          startDay: "",
          endDay: "",
        },
        {
          type: 0,
          name: "备注",
          tagname: "dong_remark",
          attributeType: 1,
          textType: 1,
          value: "",
        },
      ],
      ddAttrList: [],
      ddAttrListValue: [],
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    // 计算标签数量
    selectLabelCount() {
      const count = this.dataListSelect.reduce((pre, next) => {
        return pre + next.children.length;
      }, 0);
      return count;
    },
    // 分组名称
    getGroupName() {
      return (idx) => {
        if (idx == 0) {
          return "A组合集";
        } else if (idx == 1) {
          return "B组合集";
        } else if (idx == 2) {
          return "C组合集";
        } else if (idx == 3) {
          return "D组合集";
        } else if (idx == 4) {
          return "E组合集";
        }
      };
    },
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    // 是否无标签数据
    isNoData() {
      let flag = true;
      this.dataList.forEach((item) => {
        // 有搜索结果，flag改为false
        if (item.searchWrap) flag = false;
      });
      return flag;
    },
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    ddTimeStart() {
      return (obj) => {
        if (!obj.maxTime) {
          return {
            disabledDate: (time) => {
              return time.getTime() > Date.now();
            },
          };
        } else {
          return {
            disabledDate: (time) => {
              return time.getTime() > new Date(obj.maxTime).getTime();
            },
          };
        }
      };
    },
    ddTimeEnd() {
      return (obj) => {
        if (!obj.minTime) {
          return {
            disabledDate: (time) => {
              return time.getTime() > Date.now();
            },
          };
        } else {
          return {
            disabledDate: (time) => {
              return (
                time.getTime() + 24 * 60 * 60 * 1000 <
                  new Date(obj.minTime).getTime() || time.getTime() > Date.now()
              );
            },
          };
        }
      };
    },
    showDdLabel() {
      return (label) => {
        if (label.firstLevelCategory == "客服工具") {
          return (
            this.permissionsList.includes("dong_attribute") ||
            this.permissionsList.includes("dong_label_ids")
          );
        } else {
          return true;
        }
      };
    },
    showDdAttr() {
      return (label) => {
        if (label.labelName == "dd_customer_attr") {
          return this.permissionsList.includes("dong_attribute");
        } else if (label.labelName == "dong_label_ids") {
          return this.permissionsList.includes("dong_label_ids");
        } else {
          return true;
        }
      };
    },
    showDdCount() {
      return (label) => {
        if (label.firstLevelCategory == "客服工具") {
          if (
            this.permissionsList.includes("dong_attribute") &&
            this.permissionsList.includes("dong_label_ids")
          ) {
            return 2;
          } else if (this.permissionsList.includes("dong_attribute")) {
            return 1;
          } else if (this.permissionsList.includes("dong_label_ids")) {
            return 1;
          }
        } else {
          return label.labelCount;
        }
      };
    },
  },
  watch: {
    showVisibale(newVal) {
      if (newVal) {
        this.$emit("setSelectCont", this.selectLabelCount);
        this.provinces = [];
        this.goodsClass = [];
        if (Object.keys(this.editData).length) {
          this.getHdOptions();
          // 拿到编辑条件
          // const checkDataArr = JSON.parse(this.editData.strategy);
          let combinationCrowdTagList = JSON.parse(this.editData.strategy).combinationCrowdTagList
          console.log(combinationCrowdTagList,'111');
          combinationCrowdTagList.forEach((item)=>{
            this.dataListSelect.push({
              singleType: item.singleType,
              operatorType: item.operatorType||0,
              children: [],
              checkDataArr: item.strategyList.flatMap((item) => item),
              tagnames: item.strategyList.flatMap((item) => item).map((item) => item.tagname),//把相同的tagname也存起来
            })
          })
          // const checkDataArr = obj.strategyList
          // 返回条件每一项的名字
          // const tagnames =
          // flatArr && flatArr.map((item) => item.tagname);
          // 遍历标签数组，对比每一项的名字是否相等
          this.dataListSelect.forEach((it)=>{
            this.dataList.forEach((dataItem) => {
              dataItem.data.forEach((labelItem) => {
                labelItem.data.forEach((item) => {
                  // 判断名字数组中是否存在当前item的名字
                  let isDdTag = false;
                  const ddTag = ["dong_cus_attribute"];
                  if (["dd_customer_attr"].includes(item.labelName)) {
                    this.ddLabelList.forEach((item) => {
                      ddTag.push(item.tagname);
                    });
                    ddTag.forEach((tag) => {
                      if (it.tagnames.includes(tag)) {
                        isDdTag = true;
                      }
                    });
                  }
                  if (it.tagnames.includes(item.labelName) || isDdTag) {
                    if (it.tagnames == "crm_order_no_pay") {
                      console.log(item);
                      console.log("-------");
                    }
                    // 找到所有匹配的索引（同一 labelName 在 tagnames 中可能出现多次）
                    const matchIndexes = [];
                    it.tagnames.forEach((tn, idx) => {
                      const _ddTag = ["dong_cus_attribute"];
                      if (["dd_customer_attr"].includes(item.labelName)) {
                        this.ddLabelList.forEach((dd) => _ddTag.push(dd.tagname));
                      }
                      if (tn === item.labelName || (isDdTag && _ddTag.includes(tn))) {
                        matchIndexes.push(idx);
                      }
                    });
                    if (matchIndexes.length === 0) return;

                    dataItem.isShow = true;
                    item.valueData.visible = true;
                    this.setSelectCont(1);
                    if (dataItem.firstLevelCategory == "品类标签") {
                      if (item.labelMeaning == "一级品类") {
                        this.setSelectCont(-1);
                        item.valueData.visible = false;
                      }
                      if (item.labelMeaning == "二级品类") {
                        this.setSelectCont(-1);
                        item.valueData.visible = false;
                      }
                      if (item.labelMeaning == "三级品类") {
                        this.setSelectCont(-1);
                        item.valueData.visible = false;
                      }
                      it.checkDataArr.forEach((ele) => {
                        if (ele.tagname == "item_first_cate_cd") {
                          this.goodsPerantID = ele.value[0];
                        }
                      });
                    }
                    if (dataItem.firstLevelCategory == "品牌标签") {
                      if (item.labelMeaning == "品牌id") {
                        this.setSelectCont(-1);
                        item.valueData.visible = false;
                        this.brandsList = it.checkDataArr[matchIndexes[0]].value;
                      }
                    }
                    if (item.valueData.visible) {
                      this.pinleiCategory.push(dataItem.firstLevelCategory);
                    }
                                // 客单价
                  if(item.labelName == 'crm_order_customer_price'){
                    item.valueData.minValue = it.checkDataArr[matchIndexes[0]].order_customer_price_start;
                    item.valueData.maxValue = it.checkDataArr[matchIndexes[0]].order_customer_price_end;
                    if(item.valueData.minValue && item.valueData.maxValue){
                      item.valueData.rangeType = 0;
                    } else if(item.valueData.minValue){
                      item.valueData.rangeType = 1;
                    } else if(item.valueData.maxValue){
                      item.valueData.rangeType = -1;
                    }
                  }
                  if(item.labelName == "crm_pay_order_count"){
                    item.valueData.minValue = it.checkDataArr[matchIndexes[0]].order_count_start_value;
                    item.valueData.maxValue = it.checkDataArr[matchIndexes[0]].order_count_end_value;
                    item.valueData.minTime = it.checkDataArr[matchIndexes[0]].startValue;
                    item.valueData.maxTime = it.checkDataArr[matchIndexes[0]].endValue;
                    if(item.valueData.minValue && item.valueData.maxValue){
                      item.valueData.rangeType = 0;
                    } else if(item.valueData.minValue){
                      item.valueData.rangeType = 1;
                    } else if(item.valueData.maxValue){
                      item.valueData.rangeType = -1;
                    }
                    if(item.valueData.minTime || item.valueData.maxTime){
                      item.valueData.orderTimeStatus = 1;
                    } else {
                      item.valueData.orderTimeStatus = 0;
                    }
                    item.valueData.timeRangeType = +it.checkDataArr[matchIndexes[0]].timeSelectType;
                  }
                  if(item.labelName == "crm_open_card_time"){
                    item.valueData.minTime = it.checkDataArr[matchIndexes[0]].startValue;
                    item.valueData.maxTime = it.checkDataArr[matchIndexes[0]].endValue;
                    item.valueData.timeRangeType = +it.checkDataArr[matchIndexes[0]].timeSelectType;
                  }

                    // 对每个匹配的索引都执行回显和push children
                    matchIndexes.forEach((index) => {
                      if (!it.checkDataArr[index]) return;
                      // 深拷贝一份 item，避免同一引用被多次覆盖导致 children 中各项值相同
                      const itemCopy = JSON.parse(JSON.stringify(item));
                      // 每个配置项分配独立的 key，保证同标签重复添加时时间限制相互独立
                      itemCopy.__pickerKey = this.createPickerKey();
                    /**
                     * 内容回显
                     * labelDisplayType 对应的内容类型
                     * 0: 单选, 1: 多选, 2: 滑块取值, 3: 区间范围选择, 4: 时间范围选择, 5: 指定商品 指定sku, 6: 商品类目, 7: 选择省市,8:直播输入框
                     */
                    switch (itemCopy.labelDisplayType) {
                      case 0:
                        itemCopy.valueData.value = it.checkDataArr[index].value;
                        break;
                      case 10:
                        let start = it.checkDataArr[index].startValue;
                        let end = it.checkDataArr[index].endValue;
                        this.$set(
                          itemCopy.valueData,
                          "startMonth",
                          start.substring(0, start.length - 2),
                        );
                        this.$set(
                          itemCopy.valueData,
                          "startDay",
                          start.substring(start.length - 2),
                        );
                        this.$set(
                          itemCopy.valueData,
                          "endMonth",
                          end.substring(0, end.length - 2),
                        );
                        this.$set(
                          itemCopy.valueData,
                          "endDay",
                          end.substring(end.length - 2),
                        );
                        break;
                      case 11:
                        itemCopy.valueData.activityId =
                          it.checkDataArr[index].activityId;
                        break;
                      case 1:
                        if (itemCopy.labelName == "opdata_shop_member_channel") {
                          // 会员入会渠道
                          var valueList =
                            it.checkDataArr[index].checkValue ||
                            it.checkDataArr[index].value;
                          if (valueList && valueList.length > 0) {
                            if (valueList.length == "74") {
                              this.allSelectMembel = ["-1"];
                            }
                            var delItem = [];
                            valueList.forEach((vItem, vIndex) => {
                              if (vItem == "2") {
                                valueList.push("2,3,995,998");
                                delItem = delItem.concat([
                                  "2",
                                  "3",
                                  "995",
                                  "998",
                                ]);
                              }
                              if (vItem == "212") {
                                valueList.push("212,213");
                                delItem = delItem.concat(["212", "213"]);
                              }
                              if (vItem == "420") {
                                valueList.push("420,666");
                                delItem = delItem.concat(["420", "666"]);
                              }
                              if (vItem == "1003") {
                                valueList.push("1003,1004,1234");
                                delItem = delItem.concat([
                                  "1003",
                                  "1004",
                                  "1234",
                                ]);
                              }
                              if (vItem == "4021") {
                                valueList.push("4021,4022,4023,402");
                                delItem = delItem.concat([
                                  "4021",
                                  "4022",
                                  "4023",
                                  "402",
                                ]);
                              }

                              if (vItem == "4031") {
                                valueList.push("4031,403");
                                delItem = delItem.concat(["4031", "403"]);
                              }

                              if (vItem == "4041") {
                                valueList.push("4041,4042,404");
                                delItem = delItem.concat(["4041", "4042", "404"]);
                              }
                            });
                            delItem.forEach((delItem, delIndex) => {
                              valueList.splice(
                                this.arrayIndexOf(delItem, valueList),
                                1,
                              );
                            });
                            itemCopy.valueData.checkValue = valueList;
                            // 这里存在官方渠道id以及手动录入渠道id，需要过滤
                            const actualArr = item.enumValues.filter((dom) => {
                              return itemCopy.valueData.checkValue.some(
                                (dom1) => dom1 == dom.realValue,
                              );
                            });
                            const actualArr1 = itemCopy.valueData.checkValue.filter(
                              (dom) => {
                                return this.customIdList.some(
                                  (dom1) => dom1 == dom,
                                );
                              },
                            );
                            const actualArr2 = itemCopy.valueData.checkValue.filter(
                              (dom) => {
                                return item.enumValues.some(
                                  (dom1) => dom1.realValue == dom,
                                );
                              },
                            );

                            itemCopy.valueData.checkValue = actualArr2;
                            this.checkOfficialIdList = actualArr; // 官方渠道
                            this.checkedCustomId = actualArr1; // 手动录入渠道
                          }
                        } else {
                          itemCopy.valueData.checkValue =
                            it.checkDataArr[index].checkValue ||
                            it.checkDataArr[index].value;
                        }

                        break;
                      case 2:
                        itemCopy.valueData.slideValue =
                          it.checkDataArr[index].slideValue;
                        break;
                      case 3:
                        if (
                          it.checkDataArr[index].startValue &&
                          it.checkDataArr[index].endValue
                        ) {
                          itemCopy.valueData.rangeType = 0;
                        } else if (it.checkDataArr[index].startValue) {
                          itemCopy.valueData.rangeType = 1;
                        } else {
                          itemCopy.valueData.rangeType = -1;
                        }
                        itemCopy.valueData.minValue = it.checkDataArr[index].startValue;
                        itemCopy.valueData.maxValue = it.checkDataArr[index].endValue;
                        break;
                      case 4:
                        itemCopy.valueData.minTime = it.checkDataArr[index].startValue;
                        itemCopy.valueData.maxTime = it.checkDataArr[index].endValue;
                        itemCopy.valueData.rangeType =
                          +it.checkDataArr[index].timeSelectType;
                        if (
                          it.checkDataArr[index].value &&
                          it.checkDataArr[index].value.length > 0
                        ) {
                          itemCopy.valueData.value =
                            it.checkDataArr[index].value.split(",");
                        }
                        break;
                      case 5:
                        if (
                          (it.checkDataArr[index].itemInfo &&
                            it.checkDataArr[index].itemInfo.length > 0) ||
                          (it.checkDataArr[index].skuInfo &&
                            it.checkDataArr[index].skuInfo.length > 0)
                        ) {
                          itemCopy.valueData.skuType = 0;
                          itemCopy.valueData.goodsList = it.checkDataArr[index].value;
                          // 适应旧数据
                          if (!this.venderType && !it.checkDataArr[index].skuInfo) {
                            itemCopy.valueData.itemInfo = it.checkDataArr[index].skuInfo;
                            itemCopy.valueData.skuInfo = it.checkDataArr[index].itemInfo;
                          } else {
                            itemCopy.valueData.itemInfo =
                              it.checkDataArr[index].itemInfo;
                            itemCopy.valueData.skuInfo = it.checkDataArr[index].skuInfo;
                          }
                        } else {
                          itemCopy.valueData.skuType = 1;
                          itemCopy.valueData.value =
                            it.checkDataArr[index].value.join(",");
                        }
                        break;
                      case 6:
                        itemCopy.valueData.value = it.checkDataArr[index].value;
                        this.goodsClass = it.checkDataArr[index].value;
                        break;
                      case 7:
                        itemCopy.valueData.value = it.checkDataArr[index].value;
                        this.provinces = it.checkDataArr[index].value;
                        break;
                      case 8:
                        itemCopy.valueData.value =
                          it.checkDataArr[index].value.join(",");
                        break;
                      case 9:
                        it.checkDataArr[index].activityType &&
                          (itemCopy.valueData.activityType =
                            it.checkDataArr[index].activityType);
                        it.checkDataArr[index].activityId &&
                          (itemCopy.valueData.activityId =
                            it.checkDataArr[index].activityId);
                        break;
                    }
                    // 互动标签 - 参与指定活动
                    if (itemCopy.labelName == "hd_join_select") {
                      itemCopy.valueData.rangeType =
                        it.checkDataArr[index].timeSelectType === ""
                          ? ""
                          : +it.checkDataArr[index].timeSelectType;
                      itemCopy.valueData.minTime = it.checkDataArr[index].startValue;
                      itemCopy.valueData.maxTime = it.checkDataArr[index].endValue;

                      it.checkDataArr[index].activityType &&
                        (itemCopy.valueData.activityType =
                          it.checkDataArr[index].activityType);
                      it.checkDataArr[index].activityId &&
                        (itemCopy.valueData.activityId =
                          it.checkDataArr[index].activityId);

                      if (
                        it.checkDataArr[index].join_start_value &&
                        it.checkDataArr[index].join_end_value
                      ) {
                        itemCopy.valueData.joinRangeType = 0;
                      } else if (it.checkDataArr[index].join_start_value) {
                        itemCopy.valueData.joinRangeType = 1;
                      } else {
                        itemCopy.valueData.joinRangeType = -1;
                      }
                      itemCopy.valueData.join_start_value =
                        it.checkDataArr[index].join_start_value;
                      itemCopy.valueData.join_end_value =
                        it.checkDataArr[index].join_end_value;
                    }
                    // 互动活动参会列表
                    if (itemCopy.labelName == "opdata_shop_interact_activitys") {
                      itemCopy.valueData.mode = it.checkDataArr[index].mode;
                      if (itemCopy.valueData.mode == "0") {
                        itemCopy.valueData.activityTypes =
                          it.checkDataArr[index].activityTypes;
                        itemCopy.valueData.interactActivityIds =
                          it.checkDataArr[index].interactActivityIds;
                      } else {
                        itemCopy.valueData.activityId =
                          it.checkDataArr[index].interactActivityIds.join(",");
                      }
                    }

                    // 互动标签 - 生日时间
                    if (itemCopy.labelName == "hd_birth_time") {
                      itemCopy.valueData.startMonth = it.checkDataArr[index].startMonth;
                      itemCopy.valueData.startDay = it.checkDataArr[index].startDay;
                      itemCopy.valueData.endMonth = it.checkDataArr[index].endMonth;
                      itemCopy.valueData.endDay = it.checkDataArr[index].endDay;
                    }
                    if (dataItem.firstLevelCategory == "品类标签") {
                      it.checkDataArr.forEach((ele) => {
                        if (ele.tagname == "item_first_cate_cd") {
                          this.goodsPerantID = ele.value[0];
                        }
                      });
                      if (it.tagnames.indexOf("item_first_cate_cd") != -1) {
                        this.goodpinpei = 1;
                      }
                      if (it.tagnames.indexOf("item_second_cate_cd") != -1) {
                        this.goodpinpei = 2;
                      }
                      if (it.tagnames.indexOf("item_third_cate_cd") != -1) {
                        this.goodpinpei = 3;
                      }
                      if (item.labelMeaning == "三级品类") {
                        this.goodsClass = itemCopy.valueData.value;
                        this.goodsItem = itemCopy.valueData.value;
                      }
                    }
                    if (itemCopy.labelName == "crm_comment_status") {
                      itemCopy.valueData.commentStatus =
                        it.checkDataArr[index].commentStatus;
                      itemCopy.valueData.commentGrade =
                        it.checkDataArr[index].commentGrade;
                    }
                    if (
                      itemCopy.labelName == "crm_user_remark" ||
                      itemCopy.labelName == "crm_seller_remark"
                    ) {
                      itemCopy.valueData.remarkType = it.checkDataArr[index].remarkType;
                      itemCopy.valueData.remark = it.checkDataArr[index].remark;
                    }
                    if (
                      itemCopy.labelName == "crm_order_no_pay" ||
                      itemCopy.labelName == "crm_order_pre_sell_no_pay" ||
                      itemCopy.labelName == "crm_order_refund_success_time"
                    ) {
                      itemCopy.valueData.minTime = it.checkDataArr[index].startValue;
                      itemCopy.valueData.maxTime = it.checkDataArr[index].endValue;
                      itemCopy.valueData.rangeType =
                        +it.checkDataArr[index].timeSelectType;
                      if (
                        it.checkDataArr[index].value &&
                        it.checkDataArr[index].value.length > 0
                      ) {
                        itemCopy.valueData.value =
                          it.checkDataArr[index].value.split(",");
                      }
                    }
                    if (
                      itemCopy.labelName == "crm_order_sku_total" ||
                      itemCopy.labelName == "crm_order_refund_success_num"
                    ) {
                      if (
                        it.checkDataArr[index].startValue &&
                        it.checkDataArr[index].endValue
                      ) {
                        itemCopy.valueData.rangeType = 0;
                      } else if (it.checkDataArr[index].startValue) {
                        itemCopy.valueData.rangeType = 1;
                      } else {
                        itemCopy.valueData.rangeType = -1;
                      }
                      itemCopy.valueData.minValue = it.checkDataArr[index].startValue;
                      itemCopy.valueData.maxValue = it.checkDataArr[index].endValue;
                    }
                    if (
                      itemCopy.labelName == "crm_order_sku_buy_times" ||
                      itemCopy.labelName == "crm_order_sku_buy_total" ||
                      itemCopy.labelName == "crm_order_single_sku_buy_total"
                    ) {
                      // 时间
                      itemCopy.valueData.timeRangeType =
                        it.checkDataArr[index].timeSelectType === ""
                          ? ""
                          : +it.checkDataArr[index].timeSelectType;
                      itemCopy.valueData.minTime = it.checkDataArr[index].startValue;
                      itemCopy.valueData.maxTime = it.checkDataArr[index].endValue;
                      if (
                        it.checkDataArr[index].startValue &&
                        it.checkDataArr[index].endValue
                      ) {
                        itemCopy.valueData.orderTimeStatus = 1;
                      }
                      // 商品
                      if (
                        (it.checkDataArr[index].itemInfo &&
                          it.checkDataArr[index].itemInfo.length > 0) ||
                        (it.checkDataArr[index].skuInfo &&
                          it.checkDataArr[index].skuInfo.length > 0)
                      ) {
                        itemCopy.valueData.skuType = 0;
                        itemCopy.valueData.goodsList = [it.checkDataArr[index].skuId];
                        itemCopy.valueData.itemInfo = it.checkDataArr[index].itemInfo;
                      } else {
                        itemCopy.valueData.skuType = 1;
                        itemCopy.valueData.value = it.checkDataArr[index].skuId;
                      }

                      // 次数
                      if (
                        it.checkDataArr[index].payStart &&
                        it.checkDataArr[index].payEnd
                      ) {
                        itemCopy.valueData.rangeType = 0;
                      } else if (it.checkDataArr[index].payStart) {
                        itemCopy.valueData.rangeType = 1;
                      } else {
                        itemCopy.valueData.rangeType = -1;
                      }
                      itemCopy.valueData.minValue = it.checkDataArr[index].payStart;
                      itemCopy.valueData.maxValue = it.checkDataArr[index].payEnd;
                    }
                    if (itemCopy.labelName == "crm_order_single_sku_buy_last") {
                      // 商品
                      if (
                        (it.checkDataArr[index].itemInfo &&
                          it.checkDataArr[index].itemInfo.length > 0) ||
                        (it.checkDataArr[index].skuInfo &&
                          it.checkDataArr[index].skuInfo.length > 0)
                      ) {
                        itemCopy.valueData.skuType = 0;
                        itemCopy.valueData.goodsList = [it.checkDataArr[index].skuId];
                        itemCopy.valueData.itemInfo = it.checkDataArr[index].itemInfo;
                      } else {
                        itemCopy.valueData.skuType = 1;
                        itemCopy.valueData.value = it.checkDataArr[index].skuId;
                      }
                      // 时间
                      itemCopy.valueData.rangeType =
                        it.checkDataArr[index].timeSelectType === ""
                          ? ""
                          : +it.checkDataArr[index].timeSelectType;
                      itemCopy.valueData.minTime = it.checkDataArr[index].startValue;
                      itemCopy.valueData.maxTime = it.checkDataArr[index].endValue;
                    }
                    if (itemCopy.labelName == "dong_label_ids") {
                      this.ddAttrListValue = it.checkDataArr[index].value
                        ? it.checkDataArr[index].value
                            .split(",")
                            .map((item) => Number(item))
                        : [];
                    }
                    if (itemCopy.labelName == "dd_customer_attr") {
                      it.checkDataArr.forEach((checked) => {
                        if (ddTag.includes(checked.tagname)) {
                          if (checked.tagname == "dong_sex") {
                            this.$set(
                              this.ddLabelList[0],
                              "checkbox",
                              checked.value ? checked.value.split(",") : [],
                            );
                          } else if (checked.tagname == "dong_birth_day") {
                            this.$set(
                              this.ddLabelList[1],
                              "startMonth",
                              checked.startMonth,
                            );
                            this.$set(
                              this.ddLabelList[1],
                              "endMonth",
                              checked.endMonth,
                            );
                            this.$set(
                              this.ddLabelList[1],
                              "startDay",
                              checked.startDay,
                            );
                            this.$set(
                              this.ddLabelList[1],
                              "endDay",
                              checked.endDay,
                            );
                          } else if (checked.tagname == "dong_remark") {
                            this.$set(
                              this.ddLabelList[2],
                              "textType",
                              checked.textType,
                            );
                            this.$set(
                              this.ddLabelList[2],
                              "value",
                              checked.value,
                            );
                          } else if (checked.tagname == "dong_cus_attribute") {
                            const ddIndex = this.ddLabelList.findIndex(
                              (list) => list.cuskey == checked.cusKey,
                            );
                            if (checked.attributeType == 1) {
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "textType",
                                checked.textType,
                              );
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "value",
                                checked.value,
                              );
                            } else if (checked.attributeType == 2) {
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "radio",
                                checked.value,
                              );
                            } else if (checked.attributeType == 3) {
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "checkbox",
                                checked.value ? checked.value.split(",") : [],
                              );
                            } else if (checked.attributeType == 4) {
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "select",
                                checked.value,
                              );
                            } else if (checked.attributeType == 5) {
                              this.$set(
                                this.ddLabelList[ddIndex],
                                "rangeType",
                                Number(checked.timeSelectType),
                              );
                              if (checked.timeSelectType == 0) {
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "minTime",
                                  checked.startValue,
                                );
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "maxTime",
                                  checked.endValue,
                                );
                              } else if (checked.timeSelectType == 2) {
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "maxTime",
                                  checked.endValue,
                                );
                              } else if (checked.timeSelectType == 1) {
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "minTime",
                                  checked.startValue,
                                );
                              } else if (checked.timeSelectType == 3) {
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "minTime",
                                  checked.startValue,
                                );
                                this.$set(
                                  this.ddLabelList[ddIndex],
                                  "maxTime",
                                  checked.endValue,
                                );
                              }
                            }
                          }
                        }
                      });
                    }
                    if(index!=-1) {
                      it.children.push(itemCopy);
                      // 回显后按当前配置项自身的时间初始化限制
                      this.limitTimeRange(itemCopy);
                    }
                    }); // 关闭 matchIndexes.forEach
                  }
                });
              });
            });
          })
          console.log(this.dataListSelect,'6666');
        } else {
        }
        //判断表格是否为空
        try {
          this.dataList.forEach((item) => {
            item.data.forEach((item1) => {
              item1.data.forEach((item2) => {
                if (item2.valueData.visible == true) {
                  throw new Error("End");
                } else {
                  this.defaultShow = true;
                }
              });
            });
          });
        } catch (e) {
          if (e.message === "End") {
            this.defaultShow = false;
          } else {
            this.defaultShow = true;
          }
        }
      } else {
        // this.cleanData()
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
      }
    },
    // 监听详情数据
    editData() {
      if (this.dataList && this.dataList.length) {
        this.showVisibale = true;
      }
    },
  },
  created() {
    getSeller().then((res) => {
      if (res.code == 1) {
        this.isOrderHd = res.data.isOrderHd;
        this.permissionsList = res.data.permissions;
      } else {
        this.$message.warning(res.message);
      }
    });
    this.permissionsList = this.$store.getters.loginUserInfo.permissions
      ? this.$store.getters.loginUserInfo.permissions
      : [];
    this.shopMemberType = this.shopInfo.shopMemberType;
    this.getLabelList();
    this.getCustomQdIdList();
    advancedTags().then((res) => {
      this.advanced = res.data;
    });
    this.getHdOptions();
    this.getDdAttrList();
    this.queryList();
  },
  mounted() {
    var dotDays = localStorage.getItem("dotDays");
    var nowDays = new Date().getDate();
    this.isShowNew = dotDays != nowDays;
    // 监听中间标签盒子的滚动
    let scrollEle2 = document.getElementById("scrollEle2");
    if(scrollEle2) {
      scrollEle2.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    // 卸载监听
    let scrollEle2 = document.getElementById("scrollEle2");
    if(scrollEle2) {
      scrollEle2.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    chooseGroup(index) {
      this.groupIndex = index;
    },
    delDialogShow(index) {
      // 有无选中
      if (this.groupIndex || this.groupIndex == 0) {
        if (this.groupIndex == index) {
          if (this.dataListSelect.length - 1 == index) {
            this.dataListSelect.splice(index, 1);
            if (this.dataListSelect.length) {
              this.groupIndex = this.groupIndex - 1;
            } else {
              this.groupIndex = null;
            }
          } else {
            this.dataListSelect.splice(index, 1);
          }
        } else {
          if (this.groupIndex > index) {
            this.groupIndex = this.groupIndex - 1;
          }
          this.dataListSelect.splice(index, 1);
        }
      } else {
        this.dataListSelect.splice(index, 1);
        if (!this.dataListSelect.length) {
          this.groupIndex = null;
        }
      }
      if (this.dataListSelect.length == 0) {
        this.defaultShow = true;
      }
    },
    addGroup() {
      let obj = {
        singleType: 0, // 单组交并 0交1并
        operatorType: 0, // 对上一组的交并差操作 0交1并2差
        children: [],
      };
      this.dataListSelect.push(JSON.parse(JSON.stringify(obj)));
      this.groupIndex = this.dataListSelect.length - 1;
    },
    // 选择集合之间的交并差操作
    operatorChange(item, val) {
      item.operatorType = val;
    },
    //查询将接口数据显示出来
    queryList() {
      querymemberLevels()
        .then((res) => {
          this.memberLevels = res.data;
          console.log(this.memberLevels, "56655655665  ");
        })
        .catch((res) => {});
    },
    // 选中标签数量
    setSelectCont(num = 1) {
      // this.selectLabelCount - 0;
      // this.selectLabelCount += num;
      this.$emit("setSelectCont", this.selectLabelCount);
    },
    cleanData() {
      (this.mangeQd = true), // 管理渠道
        (this.batchDelId = []), // 批量删除id列表
        (this.checkOfficialIdList = []), // 选中的官方渠道id
        (this.checkedCustomId = []), // 已选自定义渠道id
        (this.allSelectCustomId = []), // 自定义渠道id全选
        (this.allSelectCustomIdDel = []), // 自定义渠道id全选-删除
        (this.tabIndex = "1"), // 渠道弹窗tab下标
        (this.manualId = ""), // 手动录入id
        (this.pinleiCategory = []);
      this.goodpinpei = 0;
      this.goodsPerantID = -111; // 品类  一类ID
      // this.selectLabelCount = 0;
      this.population = 0;
      this.dataList = [];
      this.brandsList = [];
      this.dataListSelect = [];
      this.getLabelList();
      this.$emit("setSelectCont", this.selectLabelCount);
    },
    // 是否有NEW图标
    isNewImg(str) {
      // let arr = ["数量相关标签", "店铺加购标签", "其他偏好标签"]
      let arr = [];
      if (arr.indexOf(str) != -1) {
        return true;
      } else {
        return false;
      }
    },
    // 时间范围验证
    timeCheck(label, value, e) {
      let timeRange = label.labelSelectRange;
      if (timeRange == "近90天") {
        if (value > 90) {
          this.$message.error("时间范围不能超过90天");
          e.target.value = "";
        }
      }
      if (timeRange == "近三年") {
        if (value > 1095) {
          this.$message.error("时间范围不能超过三年");
          e.target.value = "";
        }
      }
      if (timeRange == "近1月") {
        if (value > 30) {
          this.$message.error("时间范围不能超过1个月");
          e.target.value = "";
        }
      }
      if (timeRange == "近2年") {
        if (value > 730) {
          this.$message.error("时间范围不能超过2年");
          e.target.value = "";
        }
      }
    },
    // 获取互动相关选项
    getHdOptions() {
      let def = {
        activityName: "不限",
        id: "",
      };
      activityList({ isGetCoupon: true }).then((res) => {
        this.marketOptions.unite_get_coupon = [def, ...res.data] || [def];
      });
      activityList({ isGetCoupon: false }).then((res) => {
        this.marketOptions.uinte_open_card = [def, ...res.data] || [def];
      });
    },
    // 手动录入文本框限制
    manualIdChange(value) {
      let str = String(value.replace(/[^\d\n]/g, ""));
      const arr = str.split("\n");
      if (arr.length > 2000) {
        this.$message.warning("一次最多输入2000行");
        const otherArr = arr.slice(0, 2000);
        str = otherArr.join("\n");
        return str;
      }
      return value.replace(/[^\d\n]/g, "");
    },

    delManualId() {
      // 二次确认删除
      if (this.batchDelId.length == 0) {
        this.$message.warning("你未勾选数据，请勾选后删除");
        return;
      }
      this.$confirm(
        `已选择${this.batchDelId.length}条数据，是否确定删除`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.loading1 = true;
          delCustomQdId(this.batchDelId).then(async (res) => {
            if (res.code == 1) {
              await this.getCustomQdIdList();
              this.checkedCustomId = this.checkedCustomId.filter((item) => {
                return !this.batchDelId.includes(item);
              });
              this.allSelectCustomIdDel = [];
              this.batchDelId = [];
              this.mangeQd = true;
              this.loading1 = false;
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => {});
    },

    // 获取自定义渠道id
    getCustomQdIdList() {
      getCustomQdIdList().then((res) => {
        this.customIdList = ["全选", ...res.data];
      });
    },
    handleSwitch(index) {
      this.tabIndex = index;
    },
    // 设为常用
    setCommonUse(item, type) {
      // type: 0=>取消常用 1=>设为常用
      if (type) {
        if (this.commonUseList.length >= 10)
          return this.$message.warning("最多可自定义设置10个常用标签");
        lastUsedSave([item.labelName]).then((res) => {
          if (res.code == 1) {
            this.getCommonUse(1);
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        lastUsedDelete([item.id]).then((res) => {
          if (res.code == 1) {
            this.getCommonUse(2);
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    // 节流触发滚动，优化滚动时的卡顿
    handleScroll() {
      this.$refs.popoverRef.forEach((item) => {
        item.doClose();
      });
      // 鼠标滚动后立即隐藏tooltip
      let list = document.getElementsByClassName("el-tooltip__popper");
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
      if (this.flag1) return;
      this.flag1 = true;
      this.throttletimer = setTimeout(() => {
        this.flag1 = false;
        this.handleScrollFn();
      }, 400);
    },
    // 监听页面滚动
    handleScrollFn() {
      const navContents = document.querySelectorAll(".anchorPoint2");
      let scrollEle2 = document.getElementById("scrollEle2");
      // 监听元素滚动高度
      var currentScrollTop = scrollEle2.scrollTop;
      if (currentScrollTop == 0) {
        return (this.leftWarpTitle = "常用标签");
      }
      let that = this;
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        let temp = {
          offsetTop: item.offsetTop,
          id: item.id.slice(0, -1),
        };
        if (!item.offsetTop == 0) {
          offsetTopArr.push(temp);
        }
      });
      // 获取当前文档流的 scrollTop
      // 定义当前点亮的导航下标
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (currentScrollTop >= offsetTopArr[n].offsetTop - 200) {
          that.leftWarpTitle = offsetTopArr[n].id;
        }
        if (n == offsetTopArr.length - 1) {
          if (currentScrollTop >= offsetTopArr[n].offsetTop - 300) {
            that.leftWarpTitle = offsetTopArr[n].id;
          }
        }
      }
    },
    // 点击最左侧标签
    handleWrap(item) {
      // 左侧选择标签
      this.leftWarpTitle = item.firstLevelCategory;
      // 需要滑动的视窗
      let scrollEle2 = document.getElementById("scrollEle2");
      if(scrollEle2) {
        scrollEle2.removeEventListener("scroll", this.handleScroll);
      }
      // 锚点标签  由于id的唯一性，要和官方标签区分一下
      let id = item.firstLevelCategory + "2";
      var el = document.getElementById(id);
      // 滚动到对应锚点位置
      this.$nextTick(function () {
        scrollEle2.scrollTo({ behavior: "smooth", top: el && el.offsetTop });
      });
      setTimeout(() => {
        if(scrollEle2) {
          scrollEle2.addEventListener("scroll", this.handleScroll);
        }
      }, 1000);
    },
    // 隐藏直播标签等等
    filterCategory(val) {
      let hide = false;
      if (val == "一级品类") {
        hide = true;
      }
      if (val == "二级品类") {
        hide = true;
      }
      if (val == "三级品类") {
        hide = true;
      }
      if (val == "品牌id") {
        hide = true;
      }
      return hide != true;
    },
    switchAllSecletStatus(label) {
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
    },

    switchAlloOfficialSecletStatus(label) {
      this.checkOfficialIdList = label.enumValues.filter((item) => {
        return label.valueData.checkValue.includes(item.realValue);
      });
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
    },

    switchAllCustomSecletStatus() {
      if (this.mangeQd) {
        if (this.customIdList.length - 1 === this.checkedCustomId.length) {
          this.allSelectCustomId = ["-1"];
        } else {
          this.allSelectCustomId = [];
        }
      } else {
        if (this.customIdList.length - 1 === this.batchDelId.length) {
          this.allSelectCustomIdDel = ["-1"];
        } else {
          this.allSelectCustomIdDel = [];
        }
      }
    },

    // 全选自定义渠道id
    selectAllCustomId() {
      if (this.mangeQd) {
        if (
          this.allSelectCustomId.length == "1" &&
          this.allSelectCustomId[0] == "-1"
        ) {
          // 全选
          this.checkedCustomId = this.customIdList.slice(
            1,
            this.customIdList.length,
          );
        } else {
          // 全不选
          this.checkedCustomId = [];
        }
      } else {
        if (
          this.allSelectCustomIdDel.length == "1" &&
          this.allSelectCustomIdDel[0] == "-1"
        ) {
          // 全选
          this.batchDelId = this.customIdList.slice(
            1,
            this.customIdList.length,
          );
        } else {
          // 全不选
          this.batchDelId = [];
        }
      }
    },

    switchAllSelect(label) {
      if (
        this.allSelectMembel.length == "1" &&
        this.allSelectMembel[0] == "-1"
      ) {
        // 全选
        label.valueData.checkValue = this.memberChannel;
      } else {
        // 全不选
        label.valueData.checkValue = [];
      }
    },

    // 会员入会官方渠道全选
    switchAllOfficialSelect(label) {
      if (
        this.allSelectMembel.length == "1" &&
        this.allSelectMembel[0] == "-1"
      ) {
        // 全选
        label.valueData.checkValue = this.memberChannel;
        this.checkOfficialIdList = label.enumValues.slice(
          1,
          label.enumValues.length,
        );
      } else {
        // 全不选
        label.valueData.checkValue = [];
        this.checkOfficialIdList = [];
      }
    },

    // 添加自定义渠道id
    async addCustomQdId() {
      let arr = this.manualId.split("\n");
      arr = [...new Set(arr)]; // 数组去重
      const index = arr.indexOf(""); // 删除空数据
      if (index != -1) {
        arr.splice(index, 1);
      }
      if (arr.length == 0) {
        this.$message.warning("你未输入渠道ID，请输入后录入");
        return;
      }
      const newArr = arr.filter((item) => {
        return !this.allMemberChannel.includes(item);
      });

      this.loading = true;
      const res = await addCustomQdId(newArr);
      if (res.code == 1) {
        this.$message.success("录入成功");
        await this.getCustomQdIdList();
        this.loading = false;
      } else {
      }
    },

    // 删除已选的渠道id
    delCheckQdId(index, type, label = "") {
      // type: 1 (官方), type: 0 (自定义)
      if (type) {
        const id = this.checkOfficialIdList[index].realValue;
        this.checkOfficialIdList.splice(index, 1);
        const idx = label.valueData.checkValue.indexOf(id);
        label.valueData.checkValue.splice(idx, 1);
        if (label.valueData.checkValue.length === this.memberChannel.length) {
          this.allSelectMembel = ["-1"];
        } else {
          this.allSelectMembel = [];
        }
      } else {
        this.checkedCustomId.splice(index, 1);
        this.switchAllCustomSecletStatus();
      }
    },

    // 清空已选的渠道id
    clearCheckQdId(type, label = "") {
      // type: 1 (官方), type: 0 (自定义)
      if (type) {
        label.valueData.checkValue = [];
        this.checkOfficialIdList = [];
        this.allSelectMembel = [];
      } else {
        this.checkedCustomId = [];
        this.allSelectCustomId = [];
      }
    },

    openQdDialog(data1, data2, item) {
      const actualArr = item.enumValues.filter((dom) => {
        return item.valueData.checkValue.some((dom1) => dom1 == dom.realValue);
      });
      this.storageCustomId = JSON.parse(JSON.stringify(data1));
      this.storageOfficialId = JSON.parse(JSON.stringify(data2));
      this.storageOfficialIdList = JSON.parse(JSON.stringify(actualArr));
      this.qdVisible = true;
    },

    selectQdId() {
      this.loading = false;
      this.qdVisible = false;
      this.tabIndex = 1;
      this.mangeQd = true;
      this.batchDelId = [];
      this.allSelectCustomIdDel = [];
    },

    closeQdDialog(label) {
      label.valueData.checkValue = this.storageOfficialId;
      this.checkOfficialIdList = this.storageOfficialIdList;
      this.checkedCustomId = this.storageCustomId;
      this.loading = false;
      if (this.customIdList.length - 1 === this.checkedCustomId.length) {
        this.allSelectCustomId = ["-1"];
      } else {
        this.allSelectCustomId = [];
      }
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
      this.qdVisible = false;
      this.tabIndex = 1;
      this.mangeQd = true;
      this.batchDelId = [];
      this.allSelectCustomIdDel = [];
    },

    rangeTypeChange(label) {
      label.valueData.minValue = "";
      label.valueData.maxValue = "";
    },
    joinRangeTypeChange(label) {
      label.valueData.join_start_value = "";
      label.valueData.join_end_value = "";
    },
    timeTypeChange(label) {
      label.valueData.maxTime = "";
      label.valueData.minTime = "";
    },
    timeTypeChangeDd(item) {
      item.maxTime = "";
      item.minTime = "";
    },
    // 获取标签
    getLabelList() {
      // 店铺会员类型 shopMemberType
      var shopMemberType = this.shopMemberType;
      const labelPromise = getLabel({ lableType: 1 });
      const ddLabelPromise = getDdLabel();
      Promise.all([labelPromise, ddLabelPromise]).then((result) => {
        this.isLoading = true;
        console.log(result);
        const res = result[0];
        const ddRes = result[1];
        let labelList = {};
        // 添加咚咚客服工具
        if (res && res.data.length) {
          res.data.push(this.ddLabel);
        }
        res &&
          res.data.forEach((key, index) => {
            let count = 0;
            key.searchWrap = true;
            key.isShow = false;

            key.data.forEach((item, index2) => {
              count += item.data.length;
              item.searchTitle = true;
              item.data.forEach((label, labelIndex) => {
                if (label.labelMeaning == "市") {
                  label.labelMeaning = "省市";
                }

                if (label.labelName == "opdata_base_profession") {
                  // 客户职业
                  var list1 = label.enumValues.filter((item) => {
                    return item.realValue !== "-1";
                  });
                  var list2 = label.enumValues.filter((item) => {
                    return item.realValue === "-1";
                  });
                  list1 = list1.sort((a, b) => {
                    return +a.realValue - +b.realValue;
                  });
                  label.enumValues = list1.concat(list2);
                }

                if (label.labelName == "opdata_shop_member_channel") {
                  //会员入会渠道
                  label.labelDisplayType = 1;
                  label.hasEnumValue = true;
                  label.labelParamEsType = "terms";
                  label.labelParamRule = "0";
                  label.enumValues = [
                    { realValue: "", fieldValue: "全选" },
                    { realValue: "1", fieldValue: "商详会员价" },
                    { realValue: "2,3,995,998", fieldValue: "测试渠道" }, // 2，3, 995,998
                    { realValue: "101", fieldValue: "卡包" },
                    { realValue: "102", fieldValue: "店铺首页" },
                    { realValue: "103", fieldValue: "app支付完成页" },
                    { realValue: "104", fieldValue: "App试用频道" },
                    { realValue: "105", fieldValue: "商详页" },
                    { realValue: "106", fieldValue: "积分兑换引导" },
                    { realValue: "113", fieldValue: "APP领券入会" },
                    { realValue: "114", fieldValue: "App品牌精选" },
                    { realValue: "115", fieldValue: "App导购码" },
                    { realValue: "116", fieldValue: "App门店码" },
                    { realValue: "117", fieldValue: "App品牌码" },
                    { realValue: "119", fieldValue: "APP Jpass支付完成页" },
                    { realValue: "120", fieldValue: "短信" },
                    { realValue: "121", fieldValue: "门店详情页" },
                    { realValue: "130", fieldValue: "APP-群聊(群内)" },
                    { realValue: "140", fieldValue: "APP-京东会员频道" },
                    { realValue: "150", fieldValue: "APP-客服咚咚" },
                    { realValue: "201", fieldValue: "开普勒" },
                    { realValue: "202", fieldValue: "Jzone" },
                    {
                      realValue: "203",
                      fieldValue: "小程序商详:会员价开卡楼层",
                    },
                    { realValue: "212,213", fieldValue: "小程序领券入会" }, // 212,213
                    { realValue: "214", fieldValue: "小程序品牌精选" },
                    { realValue: "215", fieldValue: "小程序导购码" },
                    { realValue: "216", fieldValue: "小程序门店码" },
                    { realValue: "217", fieldValue: "小程序品牌码" },
                    { realValue: "218", fieldValue: "小程序支付完成页" },
                    { realValue: "219", fieldValue: "小程序卡包" },
                    { realValue: "220", fieldValue: "门店帮导购" },
                    { realValue: "301", fieldValue: "金融app" },
                    { realValue: "401", fieldValue: "H5页面" },
                    { realValue: "405", fieldValue: "m站商详:会员价开卡楼层" },
                    { realValue: "411", fieldValue: "快闪店" },
                    { realValue: "420,666", fieldValue: "联合开卡" },
                    { realValue: "430", fieldValue: "储值卡" },
                    { realValue: "501", fieldValue: "微q店铺首页" },
                    { realValue: "502", fieldValue: "微q商详" },
                    { realValue: "503", fieldValue: "微q结算页" },
                    { realValue: "504", fieldValue: "微q商详:会员价开卡楼层" },
                    { realValue: "601", fieldValue: "7-fresh" },
                    { realValue: "602", fieldValue: "溯源售后" },
                    { realValue: "603", fieldValue: "1元联合开卡" },
                    { realValue: "701", fieldValue: "商家自定义" },
                    { realValue: "801", fieldValue: "isv自定义" },
                    { realValue: "920", fieldValue: "通讯手机狂欢城" },
                    { realValue: "999", fieldValue: "默认渠道" },
                    { realValue: "1003,1004,1234", fieldValue: "分享" }, // 1003,1004,1234
                    { realValue: "1301", fieldValue: "APP-群聊(群入口)" },
                    { realValue: "2011", fieldValue: "开普勒-小程序拼券" },
                    { realValue: "3021", fieldValue: "h5砍价活动" },
                    { realValue: "3022", fieldValue: "小程序砍价活动" },
                    { realValue: "4021,4022,4023,402", fieldValue: "社交魔方" }, // 4021,4022,4023,402
                    { realValue: "4031,403", fieldValue: "大促活动" },
                    { realValue: "4032", fieldValue: "大促活动-互动会场" },
                    { realValue: "4033", fieldValue: "大促活动-预售会场" },
                    { realValue: "4034", fieldValue: "大促活动-狂欢城" },
                    { realValue: "4035", fieldValue: "大促活动-星店长" },
                    {
                      realValue: "4036",
                      fieldValue: "大促活动-20年618会员价会场",
                    },
                    {
                      realValue: "4037",
                      fieldValue: "大促活动-20年618isv互动会场",
                    },
                    { realValue: "4041,4042,404", fieldValue: "锦鲤抽奖" }, // 4041, 4042, 404
                  ];
                }

                label.valueData = {
                  minValue: "",
                  maxValue: "",
                  rangeType: label.labelName == "hd_join_select" ? "" : 0, // 区间范围的值 0: 区间 1:大于 -1：小于
                  slideValue: 0, // 滑动组件的值
                  minTime: "",
                  maxTime: "",
                  itemInfo: [], // 商品信息
                  skuInfo: [],
                  skuType: 0, // 0. 指定商品 1.指定sku
                  checkValue: [], // sku的值
                  value: "",
                  visible: false,
                  goodsList: [],
                  activityType: "",
                  activityId: "",
                  // 互动标签-参与指定互动 参数 时间相关用4的参数，活动相关用9的参数
                  join_start_value: "",
                  join_end_value: "",
                  timeRangeType: 0,
                  orderTimeStatus: 0,
                  joinRangeType: 0,
                  // 互动标签-生日时间 参数
                  startMonth: "",
                  startDay: "",
                  endMonth: "",
                  endDay: "",
                  // 互动活动参会列表
                  activityTypes: [""], // 活动类型
                  interactActivityIds: [""], // 活动ID
                  mode: "0", // 0指定活动 1指定活动id
                  // 备注-参数
                  remarkType: "0", // 0无备注1有备注
                  remark: "", // 备注内容
                  // 评价状态参数
                  commentStatus: 1, // 评价状态 0未评价 1已评价
                  commentGrade: [], // 评价等级
                };

                label.searchItem = true;
                labelList[label.labelName] = {
                  name: label.labelMeaning,
                  enumValues: label.enumValues,
                  labelDisplayType: label.labelDisplayType,
                };

                // 根据会员标签隐藏某些属性
                if (shopMemberType == "2" || shopMemberType == "4") {
                  // 隐藏 品牌会员、品牌会员等级、用户品牌积分余额、品牌会员开卡时间
                  if (
                    label.labelName == "opdata_shop_brand_member_flag" ||
                    label.labelName == "opdata_shop_brand_member_level" ||
                    label.labelName == "opdata_brand_points" ||
                    label.labelName == "opdata_shop_brand_bindingcard_tm"
                  ) {
                    label.isHide = true;
                  }
                } else if (shopMemberType == "3" || shopMemberType == "5") {
                  // 隐藏 店铺开卡会员、店铺会员等级、店铺积分余额、店铺会员开卡时间
                  if (
                    label.labelName == "opdata_shop_card_member_flag" ||
                    label.labelName == "opdata_shop_member_level" ||
                    label.labelName == "opdata_shop_points" ||
                    label.labelName == "opdata_shop_bindingcard_tm"
                  ) {
                    label.isHide = true;
                  }
                }
                // 云起标签多选写死
                if (label.labelName == "crm_order_status") {
                  // 订单状态
                  label.enumValues = [
                    { realValue: "WAIT_PAYMENT", fieldValue: "未付款" },
                    {
                      realValue: "WAIT_SELLER_STOCK_OUT",
                      fieldValue: "等待出库",
                    },
                    {
                      realValue: "WAIT_GOODS_RECEIVE_CONFIRM",
                      fieldValue: "等待确认收货",
                    },
                    { realValue: "FINISHED_L", fieldValue: "完成订单" },
                    { realValue: "TRADE_CANCELED", fieldValue: "取消订单" },
                    { realValue: "LOCKED", fieldValue: "退货订单" },
                    { realValue: "PAUSE", fieldValue: "暂停订单" },
                  ];
                }
                if (label.labelName == "crm_pre_sell_order_status") {
                  // 预售订单状态\
                  if (this.venderType == 1) {
                    label.enumValues = [
                      // 自营
                      {
                        realValue: "WAIT_PAYMENT",
                        fieldValue: "已付定金未付尾款",
                      },
                      {
                        realValue: "WAIT_SELLER_STOCK_OUT",
                        fieldValue: "等待出库",
                      },
                      {
                        realValue: "WAIT_GOODS_RECEIVE_CONFIRM",
                        fieldValue: "等待确认收货",
                      },
                      { realValue: "FINISHED_L", fieldValue: "完成订单" },
                      { realValue: "TRADE_CANCELED", fieldValue: "取消订单" },
                      { realValue: "LOCKED", fieldValue: "退货订单" },
                      { realValue: "PAUSE", fieldValue: "暂停订单" },
                    ];
                  } else {
                    label.enumValues = [
                      // POP
                      { realValue: "0", fieldValue: "未付定金/全款" },
                      { realValue: "1", fieldValue: "定金已付" },
                      { realValue: "2", fieldValue: "尾款已付" },
                      { realValue: "3", fieldValue: "全款支付完成" },
                      { realValue: "11", fieldValue: "未付定金" },
                      { realValue: "12", fieldValue: "未付完定金" },
                      { realValue: "13", fieldValue: "定金超付" },
                      { realValue: "22", fieldValue: "未付完尾款" },
                      { realValue: "23", fieldValue: "尾款超付" },
                      { realValue: "31", fieldValue: "全款未支付完" },
                      { realValue: "33", fieldValue: "全款支付超付" },
                      { realValue: "99", fieldValue: "商家违约" },
                      {
                        realValue:
                          "21,121,131,221,311,990,991,992,993,994,995,1000,1001,2000",
                        fieldValue: "取消",
                      },
                    ];
                  }
                }
                if (label.labelName == "crm_pay_status") {
                  // 支付状态
                  label.enumValues = [
                    { realValue: "0", fieldValue: "已支付" },
                    { realValue: "1", fieldValue: "未支付" },
                  ];
                  label.valueData.value = "0";
                }
                if (label.labelName == "crm_pay_type") {
                  // 付款方式
                  label.enumValues = [
                    { realValue: "1", fieldValue: "货到付款" },
                    { realValue: "2", fieldValue: "邮局汇款" },
                    { realValue: "3", fieldValue: "自提" },
                    { realValue: "4", fieldValue: "在线支付" },
                    { realValue: "5", fieldValue: "公司转账" },
                    { realValue: "6", fieldValue: "银行卡转账" },
                  ];
                }
                if (label.labelName == "crm_order_source") {
                  // 订单来源
                  label.enumValues = [
                    { realValue: "PC端订单", fieldValue: "PC端订单" },
                    { realValue: "农村电商", fieldValue: "农村电商" },
                    { realValue: "微信订单", fieldValue: "微信订单" },
                    { realValue: "手Q订单", fieldValue: "手Q订单" },
                    { realValue: "移动端订单", fieldValue: "移动端订单" },
                    { realValue: "其他", fieldValue: "其他" },
                  ];
                }
              });
            });
            key.labelCount = count;
          });
        this.dataList = res && res.data;
        // 设置客服工具标签
        this.getDdLabelList(ddRes);
        // 设置标签属性
        if (this.dataList.length > 0) {
          this.dataList.forEach((key, index) => {
            key.data.forEach((item, index2) => {
              item.data.forEach((label, index3) => {
                if (!this.isShowNew) {
                  label.isNew = false;
                }
                if (
                  label.labelDisplayType == 4 ||
                  label.labelName == "crm_order_sku_buy_times" ||
                  label.labelName == "crm_order_pre_sell_no_pay" ||
                  label.labelName == "crm_order_no_pay" ||
                  label.labelName == "crm_order_sku_buy_total" ||
                  label.labelName == "crm_order_single_sku_buy_total" ||
                  label.labelName == "crm_order_single_sku_buy_last" ||
                  label.labelName == "crm_pay_order_count" ||
                  label.labelName == "crm_order_customer_price" ||
                  label.labelName == "crm_open_card_time"
                ) {
                  let obj = this.dataList[index].data[index2].data[index3];
                  this.limitTimeRange(obj);
                }
              });
            });
          });
        }
        // 有详情才执行回显
        if (Object.keys(this.editData).length) {
          this.showVisibale = true;
        }
        console.log(this.dataList, "nnvvbvbv");
        // 获取常用标签
        this.getCommonUse();
      });
    },
    // 获取客服工具-客户属性
    getDdAttrList() {
      getDdAttr().then((res) => {
        if (res.data && res.data.length) {
          this.ddAttrList = res.data.map((item) => {
            return {
              ...item,
              checkbox: [],
            };
          });
        }
      });
    },
    // 获取客服工具-自定义标签
    getDdLabelList(res) {
      if (res.data && res.data.length) {
        res.data.forEach((item) => {
          if (item.attributeType == 1) {
            item.textType = 1;
            item.value = "";
          } else if (item.attributeType == 2) {
            item.radio = "";
          } else if (item.attributeType == 3) {
            item.checkbox = [];
          } else if (item.attributeType == 4) {
            item.select = "";
          } else if (item.attributeType == 5) {
            item.minTime = "";
            item.maxTime = "";
            item.rangeType = 0;
          }
          this.ddLabelList.push(item);
        });
      }
    },
    // 获取常用标签
    getCommonUse(type) {
      // 最近使用
      getLastUsed().then((res1) => {
        let recentlyRes = res1.data;
        this.dataList.forEach((key, index) => {
          key.data.forEach((item, index2) => {
            item.data.forEach((label, index3) => {
              // 添加属性  是否为最近使用=>recently   是否设置为常用=>commonUse
              label.recently = false;
              recentlyRes.forEach((labName) => {
                if (label.labelName == labName) label.recently = true;
              });
            });
          });
        });
        let recentlyList = [];
        for (var i = 0; i < recentlyRes.length; i++) {
          this.dataList.forEach((key) => {
            key.data.forEach((item) => {
              item.data.forEach((label) => {
                if (label.labelName == recentlyRes[i]) {
                  recentlyList.push(label);
                }
              });
            });
          });
        }
        this.recentlyList = recentlyList;
      });
      // 自定义设置
      getLastUsedCustom().then((res2) => {
        let commonUseRes = res2.data;
        this.dataList.forEach((key, index) => {
          key.data.forEach((item, index2) => {
            item.data.forEach((label, index3) => {
              // 添加属性  是否为最近使用=>recently   是否设置为常用=>commonUse
              label.commonUse = false;
              commonUseRes.forEach((lab) => {
                if (label.labelName == lab.labelName) {
                  label.commonUse = true;
                  label.id = lab.id;
                }
              });
            });
          });
        });
        let commonUseList = [];
        for (var i = 0; i < commonUseRes.length; i++) {
          this.dataList.forEach((key) => {
            key.data.forEach((item) => {
              item.data.forEach((label) => {
                if (label.labelName == commonUseRes[i].labelName) {
                  commonUseList.push(label);
                }
              });
            });
          });
        }
        this.commonUseList = commonUseList;
        if (type == 1) {
          this.$message.success("设为常用成功");
        } else if (type == 2) {
          this.$message.success("已取消常用");
        }
      });
    },
    // 常用标签点击
    attrClickTop(label) {
      let label1, item, labelItem;
      this.dataList.forEach((lab) => {
        lab.data.forEach((lab2) => {
          lab2.data.forEach((lab3) => {
            if (lab3.labelName == label.labelName) {
              item = lab;
              labelItem = lab2;
              label1 = lab3;
            }
          });
        });
      });
      this.attrClick(label1, item, labelItem);
      // 常用标签下选中左侧常用标签，不选中原本的标签
      this.leftWarpTitle = "常用标签";
    },
    // 左侧属性列表点击
    attrClick(label, item, labelItem) {
      console.log("点击标签", label, item, labelItem, this.selectLabelCount);
      // 人群运算最多共可选择50个人群标签
      if (this.selectLabelCount > 49) {
        return this.$message.warning("人群运算最多共可选择50个人群标签");
      }
      // 选中左侧标签菜单
      this.leftWarpTitle = item.firstLevelCategory;
      if (
        item.firstLevelCategory == "互动标签" &&
        !this.isOrderHd &&
        labelItem.secondLevelCategory != "联合营销相关标签"
      ) {
        return this.$message.warning(
          "使用互动标签需订购京获客，请订购后使用该标签~",
        );
      }
      // if ((item.firstLevelCategory == '互动标签' && this.classifyType == 1) || (item.firstLevelCategory != '互动标签' && this.classifyType == 13)) {
      //   return this.$message.warning("所选分类与标签不一致，请重新选择");
      // }
      if (
        labelItem.secondLevelCategory == "联合营销相关标签" &&
        !label.valueData.visible
      ) {
      }
      if (label.isNew) {
        this.isNewNum++;
        label.isNew = false;
        if (this.isNewNum >= "5" && !this.isSaveLocation) {
          this.isSaveLocation = true;
          var days = new Date().getDate();
          localStorage.setItem("dotDays", days);
        }
      }
      label.valueData.visible ? this.setSelectCont(-1) : this.setSelectCont(1);
      // 品类标签与其他标签而选择一
      if (!label.valueData.visible) {
        this.pinleiCategory.push(item.firstLevelCategory);
      } else {
        this.pinleiCategory.splice(
          this.pinleiCategory.indexOf(item.firstLevelCategory),
          1,
        );
      }

      let isPinlei = 1;
      const num = this.pinleiCategory.indexOf("品类标签");
      if (num == -1) {
        this.goodsPerantID = -111;
      }
      this.pinleiCategory.forEach((ele) => {
        if (ele != "品类标签") {
          isPinlei = 2;
        }
      });
      if (num != -1 && isPinlei == 2) {
        this.pinleiCategory.pop();
        this.setSelectCont(-1);
        return this.$message.warning(
          "店铺标签、品类标签、互动标签只能三选一，如选择，请删除已选标签再进行选择",
        );
      } else {
        this.goodsPerantID == -111;
      }

      label.valueData.visible = !label.valueData.visible;
      // 删除所有标签之后移除外层盒子
      this.setBoxDisplay(item);
      // if (label.valueData.visible === false) {
      label.valueData.checkValue = []; //类型2
      label.valueData.minValue = ""; //类型3
      label.valueData.maxValue = "";
      label.valueData.goodsList = [];
      label.valueData.itemInfo = [];
      label.valueData.skuInfo = [];
      label.valueData.value = [];
      label.valueData.startValue = "";
      label.valueData.endValue = "";
      label.valueData.maxTime = "";
      label.valueData.minTime = "";
      label.valueData.startMonth = "";
      label.valueData.startDay = "";
      label.valueData.endMonth = "";
      label.valueData.endDay = "";
      this.labels = 0; //类型5
      this.provinces = [];
      this.goodsClass = [];

      if (
        this.goodsPerantID == 1 ||
        this.pinleiCategory.indexOf("品类标签") != -1
      ) {
        this.goodsClass = this.goodsItem;
      }
      if (label.valueData.skuType) {
        label.valueData.skuType = 0;
      }
      if (label.valueData.timeRangeType) {
        label.valueData.timeRangeType = 0;
      }
      if (label.valueData.orderTimeStatus) {
        label.valueData.orderTimeStatus = 0;
      }
      const num1 = this.pinleiCategory.indexOf("品牌标签");
      if (num1 == -1) {
        this.brandsList = [];
      }
      if (label.labelName == "crm_pay_status") {
        label.valueData.value = "0";
      }
      if (label.labelName == "dd_customer_attr") {
        this.ddLabelList.forEach((item) => {
          if (item.attributeType == 1) {
            item.textType = 1;
            item.value = "";
          } else if (item.attributeType == 2) {
            item.radio = "";
          } else if (item.attributeType == 3) {
            item.checkbox = [];
          } else if (item.attributeType == 4) {
            item.select = "";
          } else if (item.attributeType == 5) {
            item.minTime = "";
            item.maxTime = "";
          }
        });
      }
      if (label.labelName == "dong_label_ids") {
        this.ddAttrList.forEach((item) => {
          item.checkbox = [];
        });
      }
      // }
      let itemObj = JSON.parse(JSON.stringify(label));
      // 每个配置项分配独立的 key，保证同标签重复添加时时间限制相互独立
      itemObj.__pickerKey = this.createPickerKey();
      // 没有分组
      if (this.dataListSelect.length == 0) {
        let obj = {
          singleType: 0, // 单组交并 0交1并
          operatorType: "", // 对上一组的交并差操作 0交1并2差
          children: [],
        };
        obj.children.push(itemObj);
        this.dataListSelect.push(JSON.parse(JSON.stringify(obj)));

        this.groupIndex = this.dataListSelect.length - 1;
      } else {
        // 有分组且有选中分组
        if (this.groupIndex || this.groupIndex == 0) {
          this.dataListSelect[this.groupIndex].children.push(itemObj);
        }
      }
      // 初始化当前配置项的时间选择器限制
      this.limitTimeRange(itemObj);
      // console.log(this.dataListSelect);
      //判断表格是否为空
      try {
        this.dataList.forEach((item) => {
          item.data.forEach((item1) => {
            item1.data.forEach((item2) => {
              if (item2.valueData.visible == true) {
                throw new Error("End");
              } else {
                this.defaultShow = true;
              }
            });
          });
        });
      } catch (e) {
        if (e.message === "End") {
          this.defaultShow = false;
        } else {
          this.defaultShow = true;
        }
      }
    },
    setItem(key) {
      localStorage.setItem(key, JSON.stringify(new Date()));
    },
    // 删除
    delLabel(item, val, index, i) {
      if (this.dataListSelect[index].children.length === 1) {
        this.dataListSelect.splice(index, 1);
      } else {
        this.dataListSelect[index].children.splice(i, 1);
      }
      if (this.selectLabelCount == 0) {
        this.defaultShow = true;
      }
      // this.dataList[index].children[i].visible = false;
      // this.dataList = this.dataList.map((ele) => {
      //   let obj = ele;
      //   obj.children.forEach((data) => {
      //     data.children.forEach((valueData) => {
      //       if (item.tag === valueData.tag) {
      //         valueData.visible = false;
      //       }
      //     });
      //   });
      //   return obj;
      // });
    },
    setBoxDisplay(item) {
      let status = false;
      item.data.forEach((second) => {
        if (second.data && second.data.length) {
          if (!status) {
            status = second.data.some((i) => i.valueData.visible);
          }
        }
      });
      item.isShow = status;
    },
    arrayIndexOf(item, arr) {
      if (Array.prototype.indexOf) {
        return arr.indexOf(item);
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return i;
          }
        }
      }
      return -1;
    },
    /**
     *  提交相关======================================>
     *  4.0平台版改版后标签列表单独拆分出来
     *  保存人群页面需要通过ref调用本组件函数，获取过滤好的数据
     *  目前需要调用的函数有 （ showLimitAttr  getCatelistData  getBrandData ）
     */
    // 过滤标签数据=>用于提交
    showLimitAttr() {
      if (this.selectLabelCount == 0) {
        this.$message.warning("请先选择标签");
        return false;
      }
      let combinationCrowdTagList = [];
      console.log(this.dataListSelect);
      for (let index = 0; index < this.dataListSelect.length; index++) {
        const dataItem = this.dataListSelect[index];
        if (dataItem.children.length == 0) {
          this.$message.warning(`组${index + 1}请先选择标签`);
          return;
        }
        let obj = {};
        obj.operatorType = dataItem.operatorType;
        obj.singleType = dataItem.singleType;
        // 获取勾选的属性的值
        var valueData = [];
        dataItem.children.forEach((item) => {
          valueData.push({
            ...item,
            brandID: dataItem.value,
            CategoryName: dataItem.firstLevelCategory,
          });
        });
        let { params, isFlag, tipText } = this.hanlderAttrData(valueData);
        obj.strategyList = params.map((v) => [{ ...v }]);
        if (!isFlag) {
          this.$message.warning(tipText);
          return false;
        }
        combinationCrowdTagList.push(obj);
      }
      return { combinationCrowdTagList };
    },
    hanlderAttrData(valueData) {
      let tipText = "";
      let isFlag = true;
      let params = [];
      for (let i = 0; i < valueData.length; i++) {
        let item = valueData[i];
        let param = {};
        // 单选类型
        if (item.labelDisplayType == 0) {
          !item.valueData.value &&
            ((tipText = item.labelMeaning + "：没有选择单选项"),
            (isFlag = false));
          param.value = item.valueData.value;
        }
        // 生日类型
        if (item.labelDisplayType == 10) {
          if (
            item.valueData.startMonth &&
            item.valueData.startDay &&
            item.valueData.endMonth &&
            item.valueData.endDay
          ) {
            let start = Number(
              item.valueData.startMonth +
                item.valueData.startDay.padStart(2, "0"),
            );
            let end = Number(
              item.valueData.endMonth + item.valueData.endDay.padStart(2, "0"),
            );
            if (start <= end) {
              param.startValue =
                item.valueData.startMonth +
                item.valueData.startDay.padStart(2, "0");
              param.endValue =
                item.valueData.endMonth +
                item.valueData.endDay.padStart(2, "0");
            } else {
              tipText = item.labelMeaning + "：起始日日期不得大于结束日期";
              isFlag = false;
              break;
            }
          } else {
            tipText = item.labelMeaning + "：不能为空";
            isFlag = false;
            break;
          }
        }
        // 复选框类型
        if (item.labelDisplayType == 1) {
          if (item.labelName != "crm_comment_status") {
            if (
              item.valueData.checkValue.length == 0 &&
              item.labelExplain != "会员开卡的渠道"
            ) {
              tipText = item.labelMeaning + "：至少选一个";
              isFlag = false;
              break;
            }
            if (
              item.valueData.checkValue.length == 0 &&
              this.checkedCustomId.length == 0 &&
              item.labelExplain == "会员开卡的渠道"
            ) {
              tipText = item.labelMeaning + "：至少选一个";
              isFlag = false;
              break;
            }
            // 会员入会渠道
            if (item.labelName == "opdata_shop_member_channel") {
              var valueList = JSON.parse(
                JSON.stringify(item.valueData.checkValue),
              );
              var delItem = [];
              valueList.forEach((vItem, checkIndex) => {
                if (vItem == "2,3,995,998") {
                  // 2,3 测试渠道
                  delItem.push(vItem);
                  valueList.push("2");
                  valueList.push("3");
                  valueList.push("995");
                  valueList.push("998");
                } else if (vItem == "212,213") {
                  // 212,213 小程序领券入会
                  delItem.push(vItem);
                  valueList.push("212");
                  valueList.push("213");
                } else if (vItem == "420,666") {
                  // 420,666 联合开卡
                  delItem.push(vItem);
                  valueList.push("420");
                  valueList.push("666");
                } else if (vItem == "1003,1004,1234") {
                  // 1003,1004,1234 分享
                  delItem.push(vItem);
                  valueList.push("1003");
                  valueList.push("1004");
                  valueList.push("1234");
                } else if (vItem == "4021,4022,4023,402") {
                  // 4021,4022,4023,402 社交魔方
                  delItem.push(vItem);
                  valueList.push("4021");
                  valueList.push("4022");
                  valueList.push("4023");
                  valueList.push("402");
                } else if (vItem == "4031,403") {
                  // 4031,403 大促活动
                  delItem.push(vItem);
                  valueList.push("4031");
                  valueList.push("403");
                } else if (vItem == "4041,4042,404") {
                  // 4041, 4042 锦鲤抽奖
                  delItem.push(vItem);
                  valueList.push("4041");
                  valueList.push("4042");
                  valueList.push("404");
                }
              });
              delItem.forEach((delItem, delIndex) => {
                valueList.splice(this.arrayIndexOf(delItem, valueList), 1);
              });
              param.value = valueList;
            } else {
              param.value = item.valueData.checkValue;
            }
          }
        }
        // 滑块类型
        if (item.labelDisplayType == 2) {
          !item.valueData.slideValue &&
            ((tipText = item.labelMeaning + "：请滑动取值"), (isFlag = false));
          param.value = item.valueData.slideValue;
        }
        // 数字范围选择类型
        if (
          item.labelDisplayType == 3 ||
          item.labelName == "crm_order_sku_total" ||
          item.labelName == "crm_order_refund_success_num"
        ) {
          if (item.valueData.rangeType == "0") {
            // 区间
            if (
              item.valueData.minValue != "" &&
              item.valueData.maxValue != ""
            ) {
              if (+item.valueData.minValue > +item.valueData.maxValue) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.minValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "-1") {
            if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (
            item.valueData.rangeType == "1" &&
            item.valueData.minValue == ""
          ) {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          param.startValue = item.valueData.minValue;
          param.endValue = item.valueData.maxValue;
          if (param.endValue instanceof Array && param.endValue.length == 0) {
            param.endValue = "";
          }
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.rangeType == "-1") {
            param.startValue = "0";
          }
        }
        // 时间范围选择类型
        if (
          item.labelDisplayType == 4 ||
          item.labelName == "crm_order_no_pay" ||
          item.labelName == "crm_order_pre_sell_no_pay" ||
          item.labelName == "crm_order_refund_success_time"
        ) {
          if (item.valueData.rangeType == 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            } else if (
              item.valueData.minTime != "" &&
              item.valueData.maxTime != "" &&
              +item.valueData.minTime > +item.valueData.maxTime
            ) {
              tipText = item.labelMeaning + "：开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else {
            if (item.valueData.value == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            }
            param.value = item.valueData.value.join(",");
          }
          param.timeSelectType = item.valueData.rangeType + "";
        }
        // 指定商品 指定
        if (item.labelDisplayType == 5) {
          if (item.valueData.skuType == 0) {
            item.valueData.goodsList.length == 0 &&
              ((tipText = item.labelMeaning + "：请选择商品"),
              (isFlag = false));
            param.itemInfo = item.valueData.itemInfo;
            param.skuInfo = item.valueData.skuInfo;
            param.value = item.valueData.goodsList.map((i) => i + "");
          } else {
            !item.valueData.value.trim() &&
              ((tipText = item.labelMeaning + ": 请输入商品sku"),
              (isFlag = false));
            param.value = item.valueData.value.split(",");
          }
        }
        // 商品类目
        if (item.labelDisplayType == 6) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        // 选择省市
        if (item.labelDisplayType == 7) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        // 输入框
        if (item.labelDisplayType == 8) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少填写一个直播ID";
            isFlag = false;
          }
          param.value = item.valueData.value.split(",");
        }
        // 京获客活动 双下拉框
        if (item.labelDisplayType == 9) {
          item.valueData.activityType &&
            (param.activityType = item.valueData.activityType);
          item.valueData.activityId &&
            (param.activityId = item.valueData.activityId);
        }
        // 互动标签 - 参与指定活动
        if (item.labelName == "hd_join_select") {
          // 参与时间
          if (item.valueData.rangeType === 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            } else if (
              item.valueData.minTime != "" &&
              item.valueData.maxTime != "" &&
              +item.valueData.minTime > +item.valueData.maxTime
            ) {
              tipText = item.labelMeaning + "：开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          }
          param.timeSelectType = item.valueData.rangeType + "";
          // 指定活动
          item.valueData.activityType &&
            (param.activityType = item.valueData.activityType);
          item.valueData.activityId &&
            (param.activityId = item.valueData.activityId);
          // 参与次数
          if (item.valueData.joinRangeType == "0") {
            // 区间
            if (
              item.valueData.join_start_value != "" &&
              item.valueData.join_end_value != ""
            ) {
              if (
                +item.valueData.join_start_value >
                +item.valueData.join_end_value
              ) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.join_start_value + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.join_end_value + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.joinRangeType == "-1") {
            if (item.valueData.join_end_value + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (
            item.valueData.joinRangeType == "1" &&
            item.valueData.join_start_value == ""
          ) {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          param.join_start_value = item.valueData.join_start_value;
          param.join_end_value = item.valueData.join_end_value;
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.joinRangeType == "-1") {
            param.join_start_value = "0";
          }
        }
        // 互动标签 - 生日时间
        if (item.labelName == "hd_birth_time") {
          if (
            item.valueData.startMonth &&
            item.valueData.startDay &&
            item.valueData.endMonth &&
            item.valueData.endDay
          ) {
            let start = Number(
              item.valueData.startMonth +
                item.valueData.startDay.padStart(2, "0"),
            );
            let end = Number(
              item.valueData.endMonth + item.valueData.endDay.padStart(2, "0"),
            );
            if (start <= end) {
              param.startMonth = item.valueData.startMonth;
              param.startDay = item.valueData.startDay;
              param.endMonth = item.valueData.endMonth;
              param.endDay = item.valueData.endDay;
            } else {
              tipText = item.labelMeaning + "：起始日日期不得大于结束日期";
              isFlag = false;
              break;
            }
          } else {
            tipText = item.labelMeaning + "：不能为空";
            isFlag = false;
            break;
          }
        }
        // 互动活动参会列表
        if (item.labelName == "opdata_shop_interact_activitys") {
          if (item.valueData.mode == "1") {
            if (item.valueData.activityId.length == 0) {
              tipText = "指定活动ID不能为空";
              isFlag = false;
              break;
            }
            if (item.valueData.activityId) {
              param.interactActivityIds = item.valueData.activityId.split(",");
            } else {
              param.interactActivityIds = [];
            }
          } else {
            if (item.valueData.interactActivityIds[0] == "") {
              param.interactActivityIds = [];
            } else {
              param.interactActivityIds = item.valueData.interactActivityIds;
            }
          }
          param.mode = item.valueData.mode;
          if (item.valueData.activityTypes[0] == "") {
            param.activityTypes = [];
          } else {
            param.activityTypes = item.valueData.activityTypes;
          }
        }
        if (item.labelDisplayType == 11) {
          param.activityId = item.valueData.activityId;
        }
        // 买家备注/买家备注
        if (
          item.labelName == "crm_user_remark" ||
          item.labelName == "crm_seller_remark"
        ) {
          param.remarkType = item.valueData.remarkType;
          param.remark =
            item.valueData.remarkType == 1 ? item.valueData.remark : "";
        }
        // 评价状态
        if (item.labelName == "crm_comment_status") {
          param.commentStatus = item.valueData.commentStatus;
          param.commentGrade =
            param.commentStatus == 1 ? item.valueData.commentGrade : [];
        }
        // 商品购买次数-商品购买件数
        if (
          item.labelName == "crm_order_sku_buy_times" ||
          item.labelName == "crm_order_sku_buy_total" ||
          item.labelName == "crm_order_single_sku_buy_total"
        ) {
          // 时间
          if (item.valueData.orderTimeStatus == 1) {
            if (item.valueData.timeRangeType == 0) {
              // 区间
              if (item.valueData.minTime == "") {
                tipText = item.labelMeaning + "：下单时间开始值不能为空";
                isFlag = false;
                break;
              } else if (item.valueData.maxTime == "") {
                tipText = item.labelMeaning + "：下单时间结束值不能为空";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            } else if (item.valueData.timeRangeType == 2) {
              // 小于
              if (item.valueData.maxTime == "") {
                tipText = item.labelMeaning + "：下单时间结束值不能为空";
                isFlag = false;
                break;
              }
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            } else if (item.valueData.timeRangeType == 1) {
              // 大于
              if (item.valueData.minTime == "") {
                tipText = item.labelMeaning + "：下单时间开始值不能为空";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
            } else if (item.valueData.timeRangeType == 3) {
              if (
                item.valueData.minTime == "" &&
                item.valueData.maxTime == ""
              ) {
                tipText = item.labelMeaning + "：下单时间不能为空";
                isFlag = false;
                break;
              } else if (
                item.valueData.minTime != "" &&
                item.valueData.maxTime != "" &&
                +item.valueData.minTime > +item.valueData.maxTime
              ) {
                tipText = item.labelMeaning + "：下单时间开始值不可大于结束值";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            } else {
              if (item.valueData.value == "") {
                tipText = item.labelMeaning + "：下单时间不能为空";
                isFlag = false;
                break;
              }
              param.value = item.valueData.value.join(",");
            }
            param.timeSelectType = item.valueData.timeRangeType + "";
          } else {
            param.timeSelectType = null;
          }
          // 选择商品
          if (item.valueData.skuType == 0) {
            if (item.valueData.goodsList.length == 0) {
              tipText = item.labelMeaning + "：请选择商品";
              isFlag = false;
              break;
            }
            param.skuId = item.valueData.goodsList.join(",");
            param.itemInfo = item.valueData.itemInfo;
          } else {
            if (!item.valueData.value.trim()) {
              tipText = item.labelMeaning + ": 请输入商品sku";
              isFlag = false;
              break;
            }
            param.skuId = item.valueData.value;
          }

          // 购买次数
          if (item.valueData.rangeType == "0") {
            // 区间
            if (
              item.valueData.minValue != "" &&
              item.valueData.maxValue != ""
            ) {
              if (+item.valueData.minValue > +item.valueData.maxValue) {
                tipText = item.labelMeaning + "：购买次数开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.minValue + "" == "") {
              tipText = item.labelMeaning + "：购买次数开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：购买次数结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "-1") {
            if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：购买次数开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (
            item.valueData.rangeType == "1" &&
            item.valueData.minValue == ""
          ) {
            tipText = item.labelMeaning + "：购买次数结束值不能为空";
            isFlag = false;
            break;
          }
          param.payStart = item.valueData.minValue;
          param.payEnd = item.valueData.maxValue;
          if (param.payEnd instanceof Array && param.payEnd.length == 0) {
            param.payEnd = "";
          }
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.rangeType == "-1") {
            param.payStart = "0";
          }
        }
        // 单品最近一次购买时间
        if (item.labelName == "crm_order_single_sku_buy_last") {
          // 选择商品
          if (item.valueData.skuType == 0) {
            if (item.valueData.goodsList.length == 0) {
              tipText = item.labelMeaning + "：请选择商品";
              isFlag = false;
              break;
            }
            param.skuId = item.valueData.goodsList.join(",");
            param.itemInfo = item.valueData.itemInfo;
          } else {
            if (!item.valueData.value.trim()) {
              tipText = item.labelMeaning + ": 请输入商品sku";
              isFlag = false;
              break;
            }
            param.skuId = item.valueData.value;
          }

          // 付款时间
          if (item.valueData.rangeType == 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：最近一次付款时间开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：最近一次付款时间结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：最近一次付款时间结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：最近一次付款时间开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：最近一次付款时间不能为空";
              isFlag = false;
              break;
            } else if (
              item.valueData.minTime != "" &&
              item.valueData.maxTime != "" &&
              +item.valueData.minTime > +item.valueData.maxTime
            ) {
              tipText =
                item.labelMeaning + "：最近一次付款时间开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else {
            if (item.valueData.value == "") {
              tipText = item.labelMeaning + "：最近一次付款时间不能为空";
              isFlag = false;
              break;
            }
            param.value = item.valueData.value.join(",");
          }
          param.timeSelectType = item.valueData.rangeType + "";
        }
        // 客服工具-客户属性
        if (item.labelName == "dd_customer_attr") {
          this.ddLabelList.forEach((label) => {
            const obj = {
              type: label.type,
              group: item.labelGroup,
              tagname: label.type == 0 ? label.tagname : "dong_cus_attribute",
            };
            if (label.type == 1) {
              obj.attributeType = label.attributeType;
              obj.cusKey = label.cuskey;
            }
            if (label.attributeType == 1) {
              obj.textType = label.textType;
              obj.value = label.value;
              if (label.value) {
                params.push(obj);
              }
            } else if (label.attributeType == 2) {
              obj.value = label.radio;
              if (label.radio) {
                params.push(obj);
              }
            } else if (label.attributeType == 3) {
              obj.value = label.checkbox.join(",");
              if (label.checkbox.length) {
                params.push(obj);
              }
            } else if (label.attributeType == 4) {
              obj.value = label.select;
              if (label.select) {
                params.push(obj);
              }
            } else if (label.attributeType == 5) {
              if (label.type == 0) {
                obj.startMonth = label.startMonth;
                obj.startDay = label.startDay;
                obj.endMonth = label.endMonth;
                obj.endDay = label.endDay;
                if (
                  label.startMonth &&
                  label.startDay &&
                  label.endMonth &&
                  label.endDay
                ) {
                  params.push(obj);
                }
              } else {
                obj.timeSelectType = String(label.rangeType);
                if (label.rangeType == 0) {
                  obj.startValue = label.minTime;
                  obj.endValue = label.maxTime;
                  if (label.minTime && label.maxTime) {
                    params.push(obj);
                  }
                } else if (label.rangeType == 2) {
                  obj.endValue = label.maxTime;
                  if (label.maxTime) {
                    params.push(obj);
                  }
                } else if (label.rangeType == 1) {
                  obj.startValue = label.minTime;
                  if (label.minTime) {
                    params.push(obj);
                  }
                } else if (label.rangeType == 3) {
                  obj.startValue = label.minTime;
                  obj.endValue = label.maxTime;
                  if (label.minTime && label.maxTime) {
                    params.push(obj);
                  }
                }
              }
            }
          });
        }
        // 客服工具-自定义标签
        if (item.labelName == "dong_label_ids") {
          console.log(this.ddAttrListValue);
          const obj = {
            group: item.labelGroup,
            value: this.ddAttrListValue.join(","),
            tagname: "dong_label_ids",
          };
          params.push(obj);
          if (!this.ddAttrListValue.length) {
            tipText = `请完善自定义标签`;
            isFlag = false;
          }
        }
        if (
          item.labelName != "dd_customer_attr" &&
          item.labelName != "dong_label_ids"
        ) {
          param = Object.assign(param, {
            group: item.labelGroup,
            tagname: item.labelName,
            type: item.labelParamEsType,
            paramRules: String(item.labelParamRule),
          });
          params.push(param);
        }
        // 付款订单数 || 客单价
        if (
          item.labelName == "crm_pay_order_count" ||
          item.labelName == "crm_order_customer_price"
        ) {
          // 时间
          if (item.valueData.orderTimeStatus == 1) {
            if (item.valueData.timeRangeType == 0) {
              // 区间
              if (item.valueData.minTime == "") {
                tipText = item.labelMeaning + "：付款时间开始值不能为空";
                isFlag = false;
                break;
              } else if (item.valueData.maxTime == "") {
                tipText = item.labelMeaning + "：付款时间结束值不能为空";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            } else if (item.valueData.timeRangeType == 2) {
              // 小于
              if (item.valueData.maxTime == "") {
                tipText = item.labelMeaning + "：付款时间结束值不能为空";
                isFlag = false;
                break;
              }
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            } else if (item.valueData.timeRangeType == 1) {
              // 大于
              if (item.valueData.minTime == "") {
                tipText = item.labelMeaning + "：付款时间开始值不能为空";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
            } else if (item.valueData.timeRangeType == 3) {
              if (
                item.valueData.minTime == "" &&
                item.valueData.maxTime == ""
              ) {
                tipText = item.labelMeaning + "：付款时间不能为空";
                isFlag = false;
                break;
              } else if (
                item.valueData.minTime != "" &&
                item.valueData.maxTime != "" &&
                +item.valueData.minTime > +item.valueData.maxTime
              ) {
                tipText = item.labelMeaning + "：付款时间开始值不可大于结束值";
                isFlag = false;
                break;
              }
              param.startValue = item.valueData.minTime;
              param.endValue = item.valueData.maxTime;
              if (
                param.endValue instanceof Array &&
                param.endValue.length == 0
              ) {
                param.endValue = "";
              }
            }
            param.timeSelectType = item.valueData.timeRangeType + "";
          } else {
            param.timeSelectType = null;
          }
          // 区间
          if (item.valueData.rangeType == "0") {
            if (
              item.valueData.minValue != "" &&
              item.valueData.maxValue != ""
            ) {
              if (+item.valueData.minValue > +item.valueData.maxValue) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.minValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "-1") {
            if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (
            item.valueData.rangeType == "1" &&
            item.valueData.minValue == ""
          ) {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          if (item.labelName == "crm_pay_order_count") {
            param.order_count_start_value = item.valueData.minValue;
            param.order_count_end_value = item.valueData.maxValue;
          } else if (item.labelName == "crm_order_customer_price") {
            param.order_customer_price_start = item.valueData.minValue;
            param.order_customer_price_end = item.valueData.maxValue;
          }
        }
        // 会员开卡时间
        if (item.labelName == "crm_open_card_time") {
          // 时间
          if (item.valueData.timeRangeType == 0) {
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开卡时间开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：开卡时间结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.timeRangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：开卡时间结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.timeRangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开卡时间开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.timeRangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：开卡时间不能为空";
              isFlag = false;
              break;
            } else if (
              item.valueData.minTime != "" &&
              item.valueData.maxTime != "" &&
              +item.valueData.minTime > +item.valueData.maxTime
            ) {
              tipText = item.labelMeaning + "：开卡时间开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          }
          param.timeSelectType = item.valueData.timeRangeType + "";
        }
        params.map((item) => {
          console.log(item.tagname,this.checkedCustomId);
          if (item.tagname == "opdata_shop_member_channel") {
            this.checkedCustomId.map((item1) => {
              item1 = String(item1);
            });
            item.value = [...item.value, ...this.checkedCustomId];
          }
        });
      }
      return {
        params,
        isFlag,
        tipText,
      };
    },
    // 获取品类标签提交数据
    getCatelistData() {
      let catelist = [];
      if (
        this.goodsPerantID == -111 &&
        this.pinleiCategory.indexOf("品类标签") != -1
      ) {
        this.$message.warning("请选择品类标签的商品类目");
        return false;
      } else {
        if (this.pinleiCategory.indexOf("品类标签") != -1) {
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品类标签") {
                  let obj = {};
                  if (this.goodpinpei == 1) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else if (this.goodpinpei == 2) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "二级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "三级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  }
                }
              });
            });
          });
        }
      }
      return catelist;
    },
    // 获取品牌标签提交数据
    getBrandData() {
      let brand = [];
      if (
        this.brandsList.length == 0 &&
        this.pinleiCategory.indexOf("品牌标签") != -1
      ) {
        this.$message.warning("请选择品牌标签的品牌");
        return false;
      } else {
        if (this.pinleiCategory.indexOf("品牌标签") != -1) {
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品牌标签") {
                  let obj = {};
                  if (item.labelMeaning == "品牌id") {
                    obj.value = this.brandsList;
                    obj.group = item.labelGroup;
                    obj.type = item.labelParamEsType;
                    obj.tagname = item.labelName;
                    obj.paramRules = String(item.labelParamRule);
                    brand.push(obj);
                  }
                }
              });
            });
          });
        }
      }
      return brand;
    },
    // 标签名查询
    handleSearch() {
      this.searchStatus = true;
      let flag = false;
      let list = [];
      this.dataList.forEach((dataItem) => {
        var i = 0;
        dataItem.data.forEach((labelItem) => {
          let j = 0;
          labelItem.data.forEach((item) => {
            if (item.labelMeaning.indexOf(this.searchValue) != "-1") {
              item.searchItem = true;
              list.push(dataItem);
              i++;
              j++;
              // 是否有常用标签
              if (item.recently) flag = true;
              if (item.commonUse) flag = true;
            } else {
              item.searchItem = false;
            }
          });
          j > 0
            ? (labelItem.searchTitle = true)
            : (labelItem.searchTitle = false);
        });
        i > 0 ? (dataItem.searchWrap = true) : (dataItem.searchWrap = false);
      });

      // 锚点定位--默认定位常用标签，否则定位第一个标签
      if (flag) {
        // 显示常用标签
        this.isCommonShow = true;
        this.handleWrap({ firstLevelCategory: "常用标签" });
      } else {
        // 隐藏常用标签
        this.isCommonShow = false;
        list.length > 0 && this.handleWrap(list[0]);
      }
    },
    // 时间范围清楚
    clearTime(dataIndex, labelIndex, index) {
      var dataList = JSON.parse(JSON.stringify(this.dataListSelect));
      let obj = dataList[dataIndex].children[index];
      dataList[dataIndex].children[index].valueData.minTime = "";
      dataList[dataIndex].children[index].valueData.maxTime = "";
      this.dataListSelect = dataList;
      this.limitTimeRange(obj);
    },
    clearDdTime(item) {
      item.minTime = "";
      item.maxTime = "";
    },
    // 生成配置项唯一 key（同名标签重复添加时，各自的时间选择器限制互不影响）
    createPickerKey() {
      this.pickerKeySeed += 1;
      return "picker" + this.pickerKeySeed;
    },
    // 时间范围限制
    limitTimeRange(obj) {
      // 没有绑定唯一 key 的对象（如左侧标签源数据）不生成配置，避免同名配置共用同一份限制
      if (!obj.__pickerKey) return;
      let timeRange = obj.labelSelectRange;
      let stamp = 0;
      let dataRange = new Date();
      if (timeRange == "近90天") stamp = 91;
      if (timeRange == "近400天") stamp = 401;
      if (timeRange == "近三年") stamp = 1096;
      if (timeRange == "近1月") stamp = 31;
      if (timeRange == "近1年" || timeRange == "近一年") stamp = 366;
      if (timeRange == "近2年" || timeRange == "近两年") stamp = 731;
      if (timeRange == "历史所有") stamp = 0;
      if (stamp) {
        dataRange.setDate(dataRange.getDate() - stamp);
        dataRange = dataRange.getTime();
      }
      this.$set(
        this.pickerOptionsList,
        "pickerOptions" + obj.__pickerKey + "start",
        {
          disabledDate: (time) => {
            if (!obj.valueData.maxTime) {
              if (stamp) {
                return (
                  time.getTime() > Date.now() || time.getTime() < dataRange
                );
              } else {
                return time.getTime() > Date.now();
              }
            } else {
              let endTime = new Date(obj.valueData.maxTime).getTime();
              // 最小选择时间   (时间跨度不能大于一年时间)
              let minTime = endTime;
              if (stamp) {
                return (
                  time.getTime() > minTime ||
                  time.getTime() > Date.now() ||
                  time.getTime() < dataRange
                );
              } else {
                return time.getTime() > minTime || time.getTime() > Date.now();
              }
            }
          },
        },
      );
      this.$set(
        this.pickerOptionsList,
        "pickerOptions" + obj.__pickerKey + "end",
        {
          disabledDate: (time) => {
            if (!obj.valueData.minTime) {
              if (stamp) {
                return (
                  time.getTime() > Date.now() || time.getTime() < dataRange
                );
              } else {
                return time.getTime() > Date.now();
              }
            } else {
              let startTime = new Date(obj.valueData.minTime).getTime();
              // 最大选择时间  （时间跨度不能大于一年）
              if (stamp) {
                return (
                  time.getTime() < startTime - 8.64e7 ||
                  time.getTime() > Date.now() ||
                  time.getTime() < dataRange
                );
              } else {
                return (
                  time.getTime() < startTime - 8.64e7 ||
                  time.getTime() > Date.now()
                );
              }
            }
          },
        },
      );
    },
    ddTimeMonthInput(item, key) {
      item[key] = String(item[key]).replace(/^0|[^\d]/g, "");
    },
    ddTimeDayInput(item, key) {
      item[key] = String(item[key]).replace(/^0|[^\d]/g, "");
    },
    // 标签查询结果返回
    goBack() {
      this.dataList.forEach((dataItem) => {
        dataItem.searchWrap = true;
        dataItem.data.forEach((label) => {
          label.searchTitle = true;
          label.data.forEach((item) => {
            item.searchItem = true;
          });
        });
      });
      this.searchStatus = false;
      this.searchValue = "";
    },
    //品牌弹窗
    BrandCategory(index) {
      this.brandIndex = index;
      this.brandsList = this.brandsList
        ? this.brandsList.map((item) => {
            let obj = {};
            if (item.brandCd) {
              obj.brandCd = item.brandCd;
            } else {
              obj.brandCd = item;
            }
            return obj;
          })
        : [];
      this.pinpaiCategory = true;
    },
    // 关闭品牌
    handleBrantCategory(state, val) {
      this.pinpaiCategory = false;
      if (state) {
        this.dataList[this.brandIndex].value = val;
        this.brandsList = val;
      }
    },
    // 显示商品类目弹窗
    showCategoryDialog(dataIndex, labelIndex, index, value) {
      this.currentIndex = [dataIndex, labelIndex, index];
      // debugger;
      if (value.length > 0) {
        var goodsClass = [];
        value.forEach((item) => {
          var temp = {
            id: item.id,
          };
          goodsClass.push(temp);
        });
      }
      this.goodsClass = goodsClass ? goodsClass : [];
      this.goodsCategoryDialog = true;
    },
    // 显示Pinlei类目弹窗
    Category(index) {
      this.goodsIndex = index;
      this.goodsSel = true;
      this.goodsClass = this.goodsClass
        ? this.goodsClass.map((item) => {
            let obj = {};
            if (item.id) {
              obj.id = item.id;
            } else {
              obj.id = item;
            }
            return obj;
          })
        : [];
      this.CategoryDialog = true;
    },
    // 关闭商品类目弹窗
    closeCategory(state, val) {
      this.goodsCategoryDialog = false;
      if (state) {
        this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[
          this.currentIndex[2]
        ].valueData.value = val.map((i) => ({
          id: i.id,
        }));
        this.goodsClass = val;
        this.goodsItem = this.goodsClass;
      }
    },
    // 品类标签商品类目弹窗
    handleCategory(state, val) {
      this.CategoryDialog = false;
      if (state) {
        this.dataList[this.goodsIndex].value = val.children.map((i) => i.id);
        this.goodsPerantID = val.id;
        //二级品类判断
        if (val.type) {
          this.goodpinpei = val.type;
        }
        this.goodsClass = val.children;
        this.goodsItem = this.goodsClass;
      }
    },
    // 限制skuid 最多输入30个
    limitSkuId(dataIndex, labelIndex, index) {
      var value =
        this.dataList[dataIndex].data[labelIndex].data[index].valueData.value;
      var reg = /[^\d,，\s]/g;
      if (reg.test(value)) {
        value = value.replace(reg, "");
      }
      this.dataList[dataIndex].data[labelIndex].data[index].valueData.value =
        value.replace(/\s+/g, "");
    },

    getLocation(val, state) {
      this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[
        this.currentIndex[2]
      ].valueData.value = val;
      this.provinces = val;
    },
    // 选择省市
    handleSelectCity(dataIndex, labelIndex, index) {
      this.currentIndex = [dataIndex, labelIndex, index];
      this.cityShow = true;
    },
    // 显示选择商品弹窗
    showSelectGoods(dataIndex, index, limit) {
      // 限制选择商品数量
      this.limit = limit ? limit : null;
      this.currentIndex = [dataIndex, index];
      this.returnSelectGoods =
        this.dataListSelect[dataIndex].children[
          index
        ].valueData.itemInfo;

      this.selectGoodsSkuList =
        this.dataListSelect[dataIndex].children[index].valueData.skuInfo;
      if (this.venderType) {
        this.selectGoodsSkuList =
          this.dataListSelect[dataIndex].children[
            index
          ].valueData.itemInfo;
      }
      this.goodsState = true;
    },
    // 商品组件回调
    selectGoodsChange(val, item) {
      if (val) {
        let valArr = [];
        this.returnSelectGoods = val;
        var dataList = JSON.parse(JSON.stringify(this.dataListSelect));
        dataList[this.currentIndex[0]].children[this.currentIndex[1]].valueData.itemInfo = val;
        val.forEach((i) => {
          if (i.skuList != 0 && !this.venderType) {
            i.skuList.forEach((ele) => {
              if (ele.skuId) {
                valArr.push(ele.skuId);
              } else {
                valArr.push(ele);
              }
            });
          } else if (this.venderType) {
            valArr.push(i.skuId);
          }
        });

        let itemArr = [];
        if (!this.venderType) {
          this.selectGoodsSkuList = item;
          dataList[this.currentIndex[0]].children[this.currentIndex[1]].valueData.skuInfo = item;
          itemArr = item.map((i) => i.skuId);
        }
        // 判断是否限制选择商品数量
        if (this.limit) {
          const goodsList = this.unique(itemArr, valArr);
          if (goodsList.length != this.limit)
            return this.$message.warning("仅支持选择1个sku，请重新选择");
        }
        dataList[this.currentIndex[0]].children[this.currentIndex[1]].valueData.goodsList = this.unique(itemArr, valArr);
        this.dataListSelect = dataList;
        this.goodsState = false;
      } else {
        this.goodsState = false;
      }
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      return [...new Set([...listArr, ...listArr1])];
    },
  },
};
</script>

<style lang="scss" scoped>
.attrActive {
  display: none !important;
}

.attr-box {
  // position: relative;
  // height: 700px;
  // margin-top: 10px;
  height: 100%;
  border-top: 1px solid#EDEDED;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .attr-left-box {
    display: inline-block;
    // padding: 12px;
    background: #fff;
    // border-radius: 8px;
    width: 488px;
    height: 100%;
    border-right: 1px solid #eeeeee;
    // @media screen and (min-width: 1440px){
    //   width: 455px;
    // }
    // @media screen and (max-width: 1440px){
    //   width: 408px;
    // }
    &-content {
      height: calc(100% - 50px);
      display: flex;
    }
  }
  .search-line {
    // margin: auto;
    margin-top: 16px;
    margin-bottom: 12px;
    position: relative;
    width: 456px;
    // @media screen and (min-width: 1440px){
    //   width: 431px;
    // }
    // @media screen and (max-width: 1440px){
    //   width: 384px;
    // }
    // /deep/.el-input {
    //   input {
    //     border-radius: 32px;
    //     height: 32px;
    //     background: #F5F5F7;
    //     font-size: 13px;
    //     font-family: PingFang SC-Regular, PingFang SC;
    //     font-weight: 400;
    //     color: #999999;
    //     border: 1px solid #F5F5F7;
    //     &:focus {
    //       border: 1px solid #2768ff;
    //       background: #fff;
    //     }
    //   }
    // }

    i {
      color: #cccccc;
      font-size: 14px;
      line-height: 32px;
      position: absolute;
      right: 10px;
      top: 0;
      cursor: pointer;
    }
  }
  .attr-leftbigProbox {
    display: inline-block;
    width: 127px;
    // width: 116px;
    // @media screen and (min-width: 1440px){
    //   width: 116px;
    // }
    // @media screen and (max-width: 1440px){
    //   width: 104px;
    // }
    height: 100%;
    border-right: 1px solid #efefef;
    position: relative;

    .attr-leftbigTabbox {
      height: 100%;
      overflow: auto;
    }

    .attr-itemPro-wrap {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      position: relative;
      .cont {
        border-radius: 50%;
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 10px;
        text-align: center;
        background: #fe4d45;
        color: #fff;
        position: absolute;
        right: 1px;
        top: 12px;
      }
    }

    .attr-itemPro-wrapClick {
      background-color: #f4f6ff;
      color: #2768ff;
    }

    .attr-itemPro-wrap:hover {
      background-color: #f4f6ff;
      color: #2768ff;
    }
  }

  .attr-leftbigbox {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    // width: 315px;
    width: 344px;
    height: calc(100% - 10px);
    overflow-y: auto;
    padding: 0 16px;
    // @media screen and (min-width: 1440px){
    //   width: 315px;
    // }
    // @media screen and (max-width: 1440px){
    //   width: 280px;
    // }

    .attr-left {
      box-sizing: border-box;
      // padding-left: 14px;
      height: 100%;

      .noData {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          // margin-left: 100px;
          // margin-top: 93px;
        }
      }

      .popoverTips {
        height: 42px;
      }

      .toolTipSet {
        transition-duration: 0ms !important;
        transition-delay: 0ms !important;
      }

      .icon-dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        background-color: #f56c6c;
        border-radius: 50%;
        vertical-align: 10%;
      }

      .search-result {
        padding-bottom: 10px;
        padding-top: 15px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        color: #333;

        .go-back {
          color: #2768ff;
          cursor: pointer;
        }
      }

      .attr-item-wrap {
        box-sizing: border-box;
        margin-bottom: 20px;

        h4 {
          margin-top: 6px;
          padding-left: 10px;
          border-left: 2px solid #2768ff;
          color: #333333;
          font-family: PingFang SC, PingFang SC;
        }
      }

      .commonlyuse-label {
        margin-bottom: 30px;
        width: 312px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #ededed;
        box-sizing: border-box;
        &-title {
          width: 100%;
          height: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f5f6f9;
          border-radius: 4px;
          &-text {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: bold;
            font-size: 14px;
            color: #252525;
            font-style: normal;
            text-transform: none;
          }
          &-num {
            margin-left: 4px;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;
          }
        }
        &-content {
          box-sizing: border-box;
          padding: 12px 12px 0 12px;
          &-label {
            padding-bottom: 6px;
            border-bottom: 1px solid #ededed;
          }
          .attr-list {
            padding-top: 8px;

            .over-ellipsis {
              height: 32px;
              line-height: 32px;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }

            .attr-padd {
              width: 140px;
              // @media screen and (min-width: 1440px) {
              //   width: 140px;
              // }
              // @media screen and (max-width: 1440px) {
              //   width: 122px;
              // }
              box-sizing: border-box;
              height: 32px;
              line-height: 32px;
              cursor: pointer;
              display: inline-block;
              position: relative;
              color: #666666;
              text-align: center;
              // margin: 0 0 8px 0;

              &:nth-child(1n) {
                // padding: 0 5px 0 0;
                margin-right: 8px;
                margin-bottom: 8px;
              }

              &:nth-child(2n) {
                // padding: 0 0 0 5px;
                margin-bottom: -8px;
                margin-right: -8px;
              }

              .attr-item {
                position: relative;
                box-sizing: border-box;
                padding: 0 5px;
                background-color: #f6f6f6;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                img {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  display: none;
                }

                &.active {
                  color: #2768ff;
                  background-color: rgba(46, 116, 254, 0.1);

                  .over-ellipsis {
                    color: #2768ff;
                  }

                  img {
                    display: block;
                  }
                }
              }
              .label__disabled {
                color: #cccccc !important;
                cursor: not-allowed;
              }
            }
          }
        }
      }

      .attr-item-box {
        margin-bottom: 7px;

        .attr-title {
          color: #999999;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          padding-bottom: 10px;
          padding-top: 12px;
        }

        // .attr-list {
        //   padding-top: 5px;

        //   .over-ellipsis {
        //     height: 32px;
        //     line-height: 32px;
        //     color: #666666;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        //     white-space: nowrap;
        //     text-align: center;
        //   }

        //   .attr-padd {
        //     @media screen and (min-width: 1440px){
        //       width: 140px;
        //     }
        //     @media screen and (max-width: 1440px){
        //       width: 122px;
        //     }
        //     box-sizing: border-box;
        //     height: 32px;
        //     line-height: 32px;
        //     cursor: pointer;
        //     display: inline-block;
        //     position: relative;
        //     color: #666666;
        //     text-align: center;
        //     margin: 0 0 8px 0;

        //     &:nth-child(1n) {
        //       padding: 0 5px 0 0;
        //     }

        //     &:nth-child(2n) {
        //       padding: 0 0 0 5px;
        //     }

        //     .attr-item {
        //       position: relative;
        //       box-sizing: border-box;
        //       padding: 0 5px;
        //       background-color: #f6f6f6;
        //       overflow: hidden;
        //       text-overflow: ellipsis;
        //       white-space: nowrap;

        //       img {
        //         position: absolute;
        //         bottom: 0;
        //         right: 0;
        //         display: none;
        //       }

        //       &.active {
        //         color: #2768FF;
        //         background-color: rgba(46,116,254,0.1);

        //         .over-ellipsis {
        //           color: #2768FF;
        //         }

        //         img {
        //           display: block;
        //         }
        //       }
        //     }
        //   }
        // }
      }
    }
  }

  .attr-rightbigbox {
    padding-left: 16px;
    background-color: #f5f6f9;
    &-top {
      background: #fff;
      // border-radius: 8px;
      // padding-bottom: 20px;
    }
    &__empty {
      // border-radius: 8px 8px 0px 0px;
    }
    display: inline-block;
    width: 969px;
    // @media screen and (min-width: 1440px){
    //   width: 969px;
    // }
    // @media screen and (max-width: 1440px){
    //   width: 936px;
    // }
    // height: 92%;

    .top-line {
      display: flex;
      align-items: center;
      padding: 16px;

      .rule-title {
        width: fit-content;
      }
      .right-title-tip {
        margin-left: 8px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ff8e0c;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      // > :nth-of-type(1) {
      //   font-weight: bold;
      //   color: #333333;
      //   .title {
      //     padding-left: 6px;
      //     border-left: 2px solid #2768ff;
      //   }
      // }

      // > :nth-of-type(2) {
      //   cursor: pointer;
      // }
    }
    // .right-scroll {
    //   background-color: #fff;
    //   height: 100%;
    //   padding-bottom: 120px;
    .attr-right {
      position: relative;
      display: inline-block;
      // vertical-align: text-top;
      width: 100%;
      height: 100%;
      padding-bottom: 124px;
      overflow: auto;
      background-color: #fff;
      &__empty {
        background-color: #fff;
      }
      .empty-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .group_collection {
        background: #fff;
        // border-radius: 4px;
        margin-left: 16px;
        margin-top: 16px;
        padding: 16px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #efefef;
      }

      .module-title {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        padding: 16px 0;
        margin-bottom: 20px;
      }

      .first-title {
        color: #333333;
      }

      .attr-content-item {
        box-sizing: border-box;
        position: relative;
        // background: #F5F5F7;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 16px;

        .del-btn {
          position: absolute;
          right: -64px;
          top: 31px;
          cursor: pointer;

          i {
            font-size: 33px;
            color: #cccccc;
          }
        }

        .title-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 16px;
          // padding-top: 8px;
          color: #333;
          background: #f5f6f9;
          .handle {
            display: flex;
            align-items: center;

            .assistant {
              width: 98px;
              height: 28px;
              line-height: 26px;
              background-color: #f6f6f6;
              border-radius: 3px;
              outline: none;
              color: #1f1f1f;
              cursor: pointer;
              transition: all 0.3s;
              i {
                margin-right: 4px;
              }

              &:hover {
                opacity: 0.8;
                color: #2768ff;
              }
            }

            .delTxt {
              color: #1f1f1f;
              font-size: 14px;
              cursor: pointer;
              .el-icon-delete:hover {
                color: #2e74fe;
              }
            }
            .delTxt:hover {
              color: #2768ff;
            }
          }
        }

        .labelExplain {
          box-sizing: border-box;
          margin: 0;
          padding: 10px 0;
          border-bottom: 1px solid #eeeeee;
          line-height: normal;
          color: #999999;
          font-size: 13px;
        }

        .radio-content {
          line-height: 28px;

          .select-qd {
            color: #333333;
            padding-right: 8px;
          }

          /deep/ .el-dialog {
            position: relative;
            margin: 0 auto 50px;
            background: #ffffff;
            border-radius: 2px;
            -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 50%;
            height: 560px;
          }

          /deep/ .el-dialog__body {
            padding: 16px 30px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
          }

          .tab-line {
            font-size: 14px;
            color: #666666;
            border-bottom: 1px solid #dddddd;
            line-height: 34px;

            .tab-item {
              text-align: center;
              width: 106px;
              height: 36px;
              line-height: 36px;
              display: inline-block;
              position: relative;
              cursor: pointer;
              margin-right: 2px;
              border: 1px solid #dddddd;
              border-bottom: none;

              span {
                position: absolute;
                width: 100%;
                left: 50%;
                height: 2px;
                transform: translateX(-50%);
                bottom: -2px;
                display: none;
              }

              &.active {
                border-top: 2px;

                span {
                  display: block;
                  background: #fff;
                }
              }
            }
          }

          .manual-input-box {
            padding: 12px;
            border: 1px solid #eeeeee;
            background-color: #f9fafb;
            border-radius: 6px;
            width: 67%;

            .manual-submit-btn {
              width: 76px;
              height: 28px;
              text-align: center;
              line-height: 28px;
              color: #fe4d45;
              background-color: #fff6f6;
              border: 1px solid #fe4d45;
              margin-top: 8px;
              cursor: pointer;
              border-radius: 2px;
            }

            /deep/ .el-textarea__inner {
              display: block;
              resize: vertical;
              padding: 5px 15px;
              line-height: 1.5;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              width: 100%;
              height: 100%;
              font-size: inherit;
              color: #333;
              background-color: #ffffff;
              background-image: none;
              border: 1px solid #eeeeee;
              border-radius: 0px;
              -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
              transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            }
          }

          .title {
            color: #fe4d45;
            padding-right: 100px;
            line-height: 22px;
            position: relative;
            margin: 16px 0 12px;
            position: relative;
            padding-left: 8px;

            &::before {
              position: absolute;
              top: 2px;
              left: 0;
              content: "*";
              color: #fe4d45;
            }

            .manage-qd {
              cursor: pointer;
              position: absolute;
              top: 0;
              right: 0;
              color: #7f85e9;
              display: flex;
              align-items: center;

              img {
                margin-right: 6px;
                vertical-align: middle;
              }
            }
          }

          .checked-box {
            .title-box {
              color: #333333;
              background-color: #f6f6f6;
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              line-height: 1;
              padding: 16px 16px 14px;

              span {
                color: #7f85e9;
              }

              .clear {
                display: flex;
                align-items: center;
                cursor: pointer;

                span {
                  color: #fe4d45;
                }

                img {
                  width: 20px;
                  height: 20px;
                }
              }
            }

            .checked-content {
              border-left: 1px solid #f6f6f6;
              border-right: 1px solid #f6f6f6;
              border-bottom: 1px solid #f6f6f6;
              padding: 14px 16px;
              max-height: 120px;
              overflow: auto;

              .checked-item {
                box-sizing: border-box;
                position: relative;
                display: inline-block;
                min-width: 100px;
                text-align: center;
                padding: 6px 6px;
                line-height: 1;
                color: #999999;
                border: 1px solid #cccccc;
                border-radius: 2px;
                margin-right: 16px;

                img {
                  cursor: pointer;
                  position: absolute;
                  top: 0;
                  right: 0;
                  transform: translate(50%, -50%);
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }

          .custom-del {
            position: absolute;
            right: 0;
            bottom: -40px;

            .assistant {
              width: 98px;
              height: 28px;
              line-height: 26px;
              background: #f7f8fe;
              border: 1px solid #2768ff;
              border-radius: 3px;
              outline: none;
              color: #2768ff;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #2768ff;
                color: #fff;
                opacity: 0.8;
              }
            }
          }

          .content-box {
            position: relative;
            height: 300px;
            overflow: auto;

            .all-check {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 999;
            }

            .flex-box-checkBox {
              display: flex;
              flex-wrap: wrap;

              /deep/ .el-checkbox {
                color: #606266;
                font-weight: 500;
                font-size: 14px;
                position: relative;
                cursor: pointer;
                display: inline-block;
                white-space: nowrap;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                margin: 0 30px 16px 0;
                height: 14px;

                &:nth-child(1) {
                  opacity: 0;
                }
              }
            }
          }

          .tips-box {
            margin-top: 12px;
            padding: 12px;
            background-color: #fafafa;
            border-radius: 3px;
            width: 67%;
            line-height: 1;

            .tips-icon {
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 0 4px 0 3px;
              vertical-align: top;
            }

            .tips-content {
              display: inline-block;
              margin-left: 2px;
              color: #333333;
              font-size: 13px;
              line-height: 13px;

              p {
                &:nth-child(2) {
                  margin: 10px 0;
                }
              }
            }
          }
        }

        .area-select {
          padding-top: 8px;
          padding-bottom: 8px;

          .to-text {
            margin: 0 8px;
          }

          .el-input {
            width: 125px;
          }

          .el-select {
            margin-right: 20px;
            width: 136px;
          }
        }

        .select-city-box {
          padding-top: 8px;
          padding-bottom: 8px;

          /deep/ .el-button {
            width: auto !important;
          }
        }

        .goods-sku-box {
          padding-top: 8px;
          padding-bottom: 8px;

          /deep/ .el-button {
            width: auto !important;
          }

          span {
            margin-right: 8px;
          }
        }

        .birth-input {
          .el-input {
            width: 80px;
          }
        }

        .content {
          padding: 12px 0;
          padding-left: 16px;
          border: 1px solid #f6f6f6;

          .birth-input {
            .el-input {
              width: 80px;
            }
          }
        }

        .slider.content {
          padding-left: 38px;
          padding-top: 8px;
          padding-bottom: 8px;
        }

        .time-range {
          padding-top: 8px;
          padding-bottom: 8px;
        }
      }

      .attr-content-item:first-child {
        margin-top: 16px;
      }
    }
    .footer-save {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 503px);
      position: absolute;
      right: 0;
      bottom: 0;
      border-top: 1px solid #ededed;
      height: 62px;
      padding: 0 16px;
      background-color: #fff;
      z-index: 99;
      .people-count {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .people-color {
        color: #fe7622;
      }
      .ml8 {
        margin-left: 8px;
      }
    }
    // }
  }
}

.btn-group {
  position: absolute;
  right: 30px;
  bottom: 20px;
  text-align: right;

  .el-button {
    width: 96px;
  }
}

.popoverWrap {
  .popoverItem {
    display: flex;
    // align-items: center;
    margin: 20px;

    &:last-child {
      margin: 20px;
    }

    img {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }

    .desc {
      display: flex;
      flex-direction: column;

      span {
        &:first-child {
          font-size: 16px;
          color: #000;
          margin-bottom: 2px;
        }

        &:last-child {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}

.popoverSet {
  height: 40px;
  margin-left: -1px !important;
  transition-duration: 50ms !important;
  transition-delay: 10ms !important;

  img {
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 1px;
  }

  .tips {
    margin-top: -5px;
    font-size: 12px;

    span {
      cursor: pointer;
    }

    .noCommon {
      color: #7f85e9;
    }

    .common {
      color: #666666;
    }
  }
}

.datePicker {
  /deep/.el-input__inner {
    text-indent: 20px !important;
  }
}
.select {
  margin-bottom: 8px;
}
.common-count-color {
  color: #ff7f23;
}
.label-style-box {
  color: #333333;
}
</style>
<style lang="scss">
.tip .el-message-box__content {
  padding-left: 60px !important;
}

// .el-message-box__content {
//   padding: 20px 0 !important;
//   padding-left: 80px !important;
//   text-align: left !important;
// }

.el-popover {
  min-width: 100px !important;
}
.popoverSet {
  height: 40px;
  margin-left: -1px !important;
  // z-index: 0;
  // transition: none !important;
  transition-duration: 50ms !important;
  transition-delay: 10ms !important;
  img {
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 1px;
  }
  .tips {
    margin-top: -5px;
    font-size: 12px;
    span {
      cursor: pointer;
    }
    .noCommon {
      color: #7f85e9;
    }
    .common {
      color: #666666;
    }
  }
}
.toolTipSet {
  transition-duration: 0ms !important;
  transition-delay: 0ms !important;
}
.popoverTips {
  height: 42px;
}
.item-wrap {
  padding: 8px 0px;
}
.flex {
  display: flex;
  align-items: center;
  &-content {
    display: flex;
    align-items: center;
    &-label {
      margin: 0px 8px;
    }
    &-r8 {
      margin-right: 8px;
    }
    &-search {
      width: 300px !important;
    }
  }
}
.margin-t16 {
  margin-top: 16px;
}

.custom-tag-checkbox {
  font-size: inherit;
}

.ml12 {
  margin-left: 12px;
}
.ml2 {
  margin-left: 2px;
}

.filter-content-right {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 16px;
    &__tip {
      width: 480px;
    }
    &-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      .hide {
        display: block;
      }
      .active {
        display: none;
      }
      &__icon {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
      &:hover {
        color: $theme-color;
        .hide {
          display: none;
        }
        .active {
          display: block;
        }
      }
    }
  }
  &-box {
    flex: 1;
    padding: 0 20px;
    overflow-y: auto;
    scrollbar-width: thin;
    &-add {
      margin-top: 16px;
    }
    &-empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &-img {
        height: 151px;
        width: 186px;
      }
      &-text {
        height: 37px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
    }
    &-group {
      &-item {
        position: relative;
        border: 1px solid #efefef;
        border-radius: 8px;
        padding: 16px;
        margin-top: 16px;
        margin-left: 16px;
        &__hover {
          position: absolute;
          top: -34px;
          left: calc(50% - 115px);
          width: 210px;
          height: 46px;
          background: #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
          border-radius: 4px 4px 4px 4px;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 8px;
          > div {
            width: 54px;
            height: 30px;
            line-height: 30px;
            background: #fff;
            border-radius: 4px 4px 4px 4px;
            text-align: center;
            cursor: pointer;
            margin-top: -2px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
          }
          .check {
            color: $theme-color;
          }
          .check2 {
            color: #3cc781;
          }
          .check3 {
            color: #ff9226;
          }
        }
        &__active {
          border: 2px solid #b3d8ff;
        }
        &-title {
          position: relative;
          color: #333333;
          line-height: 17px;
          margin-left: 0px t;
          margin-top: 14px;
          margin-bottom: 12px;
          font-weight: 500;
        }
        &-sub {
          margin-top: 16px;
          &-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 48px;
            padding: 0px 16px;
            background-color: #f8f8f8;
            border-radius: 4px 4px 0px 0px;
            color: #333;
            &-wrap {
              display: flex;
              align-items: center;
            }
            &-handle {
              display: flex;
              align-items: center;
              &-assistant {
                margin-right: 16px;
                border-radius: 3px;
                outline: none;
                cursor: pointer;
                transition: all 0.3s;
                color: #1f1f1f;
                display: flex;
                align-items: center;
                .hide {
                  display: block;
                }
                .active {
                  display: none;
                }
                &:hover {
                  .hide {
                    display: none;
                  }
                  .active {
                    display: block;
                  }
                }
                img {
                  width: 14px;
                  height: 14px;
                }
              }
              &__del {
                cursor: pointer;
                .hide {
                  display: block;
                }
                .active {
                  display: none;
                }
                img {
                  width: 14px;
                  height: 14px;
                }
                &:hover {
                  .hide {
                    display: none;
                  }
                  .active {
                    display: block;
                  }
                }
              }
              &__edit {
                margin-left: 16px;
                cursor: pointer;
                display: flex;
                align-items: center;
                .hide {
                  display: block;
                }
                .active {
                  display: none;
                }
                img {
                  width: 14px;
                  height: 14px;
                }
                &:hover {
                  .hide {
                    display: none;
                  }
                  .active {
                    display: block;
                  }
                }
              }
            }
          }
          &-label {
            padding: 16px 20px;
            border-left: 1px solid #efefef;
            border-right: 1px solid #efefef;
            border-bottom: 1px solid #efefef;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            &__text {
              line-height: normal;
              color: #999;
              // margin-bottom: 16px;
            }
            &-wrap {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              /deep/ .single-date-picker {
                width: 140px;
                .el-input__inner {
                  padding: 0px 4px;
                  font-size: 12px;
                }
                .el-input__prefix {
                  display: none;
                }
                .el-input__suffix {
                  right: -2px;
                }
              }
              /deep/ .number-range {
                width: 300px;
              }
              &__text {
                margin-right: 8px;
              }
              &__title {
                margin-right: 8px;
                color: #666666;
              }
              &:last-child {
                margin-bottom: 0px;
              }
              .input100 {
                width: 100px;
                margin-right: 8px;
                /deep/ .el-input--suffix {
                  .el-input__inner {
                    padding-right: 28px;
                  }
                }
              }
              .input120 {
                width: 120px;
                margin-right: 8px;
              }
              .input140-2 {
                width: 140px;
              }
              .input-w300 {
                width: 300px;
              }
              &__operate {
                display: flex;
                padding: 2px;
                border: 1px solid #eee;
                border-radius: 4px;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-left: 8px;
              }
            }
            &__flag {
              width: 15px;
              height: 15px;
              margin-right: 30px;
              margin-top: 3px;
            }
          }
        }
        &__top {
          overflow: hidden;
          padding: 0px 8px 0px;
          margin-bottom: 8px;
          :deep(.arco-radio-label) {
            margin-right: 10px;
            margin-left: 2px;
          }
          span {
            font-weight: 400;
            color: #333333;
            margin-right: 18px;
          }
          > img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
            float: right;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
